import React, { Component, cloneElement, createElement } from 'react';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import InputMask from 'react-input-mask';
import Moment from 'moment';
import ReactModal from 'react-modal';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Icon = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent'
};

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          negative = _props.negative,
          outline = _props.outline,
          transparent = _props.transparent,
          className = _props.className,
          children = _props.children,
          icon = _props.icon,
          iconLeft = _props.iconLeft,
          iconRight = _props.iconRight,
          onClick = _props.onClick,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          type = _props.type,
          size = _props.size,
          _props$block = _props.block,
          block = _props$block === undefined ? false : _props$block,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          htmlType = _props.htmlType;

      var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty(_classNames, '' + typeClasses[type], !!type), _defineProperty(_classNames, '' + sizeClasses[size], !!size), _defineProperty(_classNames, 'has-icon', !!icon), _defineProperty(_classNames, 'has-icon-left', !!iconLeft), _defineProperty(_classNames, 'has-icon-right', !!iconRight), _defineProperty(_classNames, 'a-button-negative', !!negative), _defineProperty(_classNames, 'a-button-outline', !!outline), _defineProperty(_classNames, 'a-button--block', block), _classNames));

      return React.createElement('button', {
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType }, icon ? React.createElement(Icon, { name: icon }) : null, iconLeft ? React.createElement(Icon, { name: iconLeft }) : null, iconRight ? React.createElement(Icon, { name: iconRight }) : null, children);
    }
  }]);

  return Button;
}(Component);

var _createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var typeClasses$1 = {
  success: 'm-alert--success',
  warning: 'm-alert--warning',
  danger: 'm-alert--danger'
};

var Alert = function (_Component) {
  _inherits$1(Alert, _Component);

  function Alert(props) {
    _classCallCheck$1(this, Alert);

    var _this = _possibleConstructorReturn$1(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));

    _this.handleClose = function (e) {
      var onClose = _this.props.onClose;

      e.preventDefault();
      onClose && onClose();
      _this.setState({ closed: true });
    };

    _this.state = {
      closing: true,
      closed: false
    };
    return _this;
  }

  _createClass$1(Alert, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          title = _props.title,
          children = _props.children,
          closable = _props.closable,
          className = _props.className;
      var closed = this.state.closed;

      var alertClass = classNames('m-alert', _defineProperty$1({}, '' + typeClasses$1[type], !!type), className);

      var closeButton = closable ? React.createElement(Button, { type: type, icon: 'close', onClick: this.handleClose, className: 'm-alert__close a-button-transparent' }) : null;

      return React.createElement('div', null, !closed ? React.createElement('div', { className: alertClass }, closeButton, title && React.createElement('h5', { className: 'u-margin-bottom-xs' }, title), children) : React.createElement('div', null));
    }
  }]);

  return Alert;
}(Component);

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var FlyoutContent = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children;

  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });

  return React.createElement('div', { className: classes }, children);
};

var _createClass$2 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$2(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$1(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$1(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var flyoutSizes = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var Flyout = function (_Component) {
  _inherits$2(Flyout, _Component);

  function Flyout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$2(this, Flyout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, (_ref = Flyout.__proto__ || Object.getPrototypeOf(Flyout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: _this.props.open
    }, _this.flyoutRef = React.createRef(), _this.toggleIsOpen = function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }
      _this.setState({ isOpen: !_this.state.isOpen });
      onStateChange(_this.state.isOpen);
    }, _this.closeFlyout = function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }
      _this.setState({ isOpen: false });
      onStateChange(false);
    }, _this.handleOutsideClick = function (e) {
      var area = ReactDOM.findDOMNode(_this.flyoutRef.current);
      if (area && !area.contains(e.target)) {
        _this.closeFlyout();
      }
    }, _this.getClassNames = function () {
      return classNames(_this.props.className, 'm-flyout', 'm-flyout--' + _this.props.direction, _defineProperty$2({
        'is-open': _this.state.isOpen,
        'm-flyout--scrollable': _this.props.scrollable
      }, 'm-flyout--' + flyoutSizes[_this.props.size], !!flyoutSizes[_this.props.size]));
    }, _temp), _possibleConstructorReturn$2(_this, _ret);
  }

  _createClass$2(Flyout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isOpen = this.state.isOpen;

      if (isOpen) {
        document.addEventListener('click', this.handleOutsideClick, false);
      }

      this.props.triggerClose(this.closeFlyout);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({ isOpen: !prevProps.open });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          hasPadding = _props.hasPadding,
          children = _props.children;

      var flyoutClass = this.getClassNames();
      return trigger && React.createElement('div', { className: flyoutClass, ref: this.flyoutRef }, React.createElement('div', { onClick: this.toggleIsOpen }, this.props.trigger), React.createElement(FlyoutContent, { hasPadding: hasPadding }, children));
    }
  }]);

  return Flyout;
}(Component);

Flyout.defaultProps = {
  direction: 'left',
  size: 'medium',
  hasPadding: false,
  open: false,
  onStateChange: function onStateChange() {},
  triggerClose: function triggerClose() {},
  scrollable: false
};

var InputLabel = function InputLabel(props) {
  var style = props.style,
      htmlFor = props.htmlFor,
      children = props.children,
      inline = props.inline;

  var labelClass = classNames('a-input__label', {
    'a-input__label--inline': !!inline
  });
  return React.createElement('label', { className: labelClass, htmlFor: htmlFor, style: style }, children);
};

var Icon$1 = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass$1$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$2$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck$1$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$1(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$1(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var stateClasses = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var TextField = function (_Component) {
  _inherits$1$1(TextField, _Component);

  function TextField() {
    _classCallCheck$1$1(this, TextField);

    return _possibleConstructorReturn$1$1(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).apply(this, arguments));
  }

  _createClass$1$1(TextField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          label = _props.label,
          value = _props.value,
          name = _props.name,
          description = _props.description,
          required = _props.required,
          placeholder = _props.placeholder,
          onChange = _props.onChange,
          onClick = _props.onClick,
          onBlur = _props.onBlur,
          onKeyDown = _props.onKeyDown,
          mask = _props.mask,
          state = _props.state,
          autoComplete = _props.autoComplete,
          disabled = _props.disabled,
          iconright = _props.iconright,
          iconleft = _props.iconleft;

      var _props2 = this.props,
          loading = _props2.loading,
          extraProps = _objectWithoutProperties(_props2, ['loading']);

      var inputClass = classNames('a-input', _defineProperty$2$1({
        'has-icon-right': iconright || loading,
        'has-icon-left': iconleft,
        'is-required': !!required
      }, '' + stateClasses[state], !!state));

      return React.createElement('div', { className: inputClass }, label && React.createElement(InputLabel, { htmlFor: id }, label), React.createElement('div', { className: 'a-input__wrapper' }, iconleft ? React.createElement(Icon$1, { name: iconleft }) : null, mask ? React.createElement(InputMask, this.props) : React.createElement('input', _extends({ type: 'text', autoComplete: autoComplete, disabled: disabled }, extraProps)), iconright ? React.createElement(Icon$1, { name: iconright }) : null, loading ? React.createElement('span', { className: 'fa a-spinner a-spinner--sm' }) : null), React.createElement('small', null, description));
    }
  }]);

  return TextField;
}(Component);

var _createClass$2$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$2$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$2$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$1(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$2$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$1(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Autocomplete = function (_Component) {
  _inherits$2$1(Autocomplete, _Component);

  function Autocomplete(props) {
    _classCallCheck$2$1(this, Autocomplete);

    var _this = _possibleConstructorReturn$2$1(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));

    _this.handleChange = function (e) {
      _this.setState({
        open: true,
        searchVal: e.target.value
      });
      _this.updateInputValue(e);
      _this.props.onChange(e.target.value);
      _this.search(e.target.value);
    };

    _this.search = function (val) {
      var items = _this.props.items;

      if (!val) {
        return _this.setState({
          results: items,
          cursor: 0
        });
      }

      var matches = items.filter(function (item) {
        return item.label.toLowerCase().includes(val.toLowerCase());
      });
      _this.setState({
        results: matches,
        cursor: 0
      });
    };

    _this.handleClick = function (e) {
      _this.props.onSelection(e.target.dataset.value);
      _this.props.onChange(e.target.dataset.value);
      _this.selectOption(e.target.innerText);
    };

    _this.toggleOpen = function () {
      _this.setState({ open: !_this.state.open });
    };

    _this.handleFlyoutState = function (isOpen) {
      _this.setState({ open: isOpen });
    };

    _this.handleKeyPress = function (e) {
      var _this$state = _this.state,
          results = _this$state.results,
          cursor = _this$state.cursor;

      if (e.key === "ArrowDown" && cursor < results.length - 1) {
        _this.setState({
          open: true,
          cursor: cursor + 1
        }, function () {
          _this.scrollToItem();
        });
      }
      if (e.key === "ArrowUp" && cursor > 0) {
        _this.setState({
          open: true,
          cursor: cursor - 1
        }, function () {
          _this.scrollToItem();
        });
      }
      if (e.key === "Enter") {
        _this.selectOption(results[cursor].label);
      }
      if (e.key === "Backspace") {
        _this.search(_this.state.inputValue);
      }
    };

    _this.scrollToItem = function () {
      var domNode = ReactDOM.findDOMNode(_this['item_' + _this.state.cursor]);
      domNode.scrollIntoView(false);
    };

    _this.selectOption = function (val) {
      _this.closeTrigger();
      _this.setState({
        inputValue: val,
        open: false
      });
    };

    _this.renderItems = function (item, index) {
      var liClasses = classNames({
        'm-selectable-list__item': true,
        'm-selectable-list__item--active': _this.state.cursor === index
      });
      return React.createElement('li', { key: item.value, 'data-value': item.value, 'data-label': item.label, className: liClasses, onClick: _this.handleClick, ref: function ref(item) {
          _this['item_' + index] = item;
        } }, item.label);
    };

    _this.handleCloseTrigger = function (closeTrigger) {
      _this.closeTrigger = closeTrigger;
    };

    var open = _this.props.open;

    _this.state = {
      open: open || false,
      inputValue: '',
      results: [],
      cursor: 0,
      searchVal: ''
    };
    return _this;
  }

  _createClass$2$1(Autocomplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          items = _props.items;

      this.setState({
        results: items
      });

      if (!defaultValue) {
        return;
      }

      this.props.onSelection(defaultValue);
      this.props.onChange(defaultValue);

      var foundItems = items.filter(function (item) {
        return item.value === defaultValue;
      });
      if (!foundItems.length > 0) {
        this.search(defaultValue);
        return this.selectOption(defaultValue);
      }
      this.search(foundItems[0].label);
      this.selectOption(foundItems[0].label);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var searchVal = this.state.searchVal;
      // This is necessarry since it takes around 1/10th of a second before the props have propagated.

      setTimeout(function () {
        return _this2.search(searchVal);
      }, 100);
    }
  }, {
    key: 'updateInputValue',
    value: function updateInputValue(e) {
      this.setState({
        inputValue: e.target.value
      });
      if (e.target.value === "") {
        this.setState({
          results: this.props.items
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          items = _props2.items,
          noResults = _props2.noResults,
          loading = _props2.loading,
          disabled = _props2.disabled,
          state = _props2.state;
      var _state = this.state,
          results = _state.results,
          open = _state.open;

      return items && React.createElement('div', null, React.createElement(Flyout, {
        trigger: React.createElement(TextField, {
          name: 'autocomplete',
          className: 'autocomplete',
          label: this.props.label,
          value: this.state.inputValue,
          onChange: this.handleChange,
          onClick: this.toggleOpen,
          onKeyDown: this.handleKeyPress,
          autoComplete: 'off',
          loading: !!loading,
          disabled: disabled,
          state: state
        }),
        triggerClose: this.handleCloseTrigger,
        onStateChange: this.handleFlyoutState,
        open: open
      }, results.length == 0 ? React.createElement('p', { className: 'u-margin-xs u-text-light u-text-center' }, noResults) : React.createElement('ul', { className: 'm-selectable-list m-selectable-list--no-border' }, results.map(function (item, index) {
        return _this3.renderItems(item, index);
      }))));
    }
  }]);

  return Autocomplete;
}(Component);

Autocomplete.defaultProps = {
  open: false,
  onSelection: function onSelection() {},
  onChange: function onChange() {},
  noResults: 'No results were found'
};

var Icon$2 = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var sizeClasses$1 = {
  small: 'a-avatar--small',
  medium: 'a-avatar--medium',
  large: 'a-avatar--large'
};

var IconWrapper = function IconWrapper(_ref) {
  var icon = _ref.icon;
  return React.createElement('span', { className: 'a-avatar__icon' }, React.createElement(Icon$2, { name: icon }));
};
var LetterWrapper = function LetterWrapper(_ref2) {
  var letter = _ref2.letter;
  return React.createElement('span', { className: 'a-avatar__letter' }, letter);
};

var Avatar = function Avatar(props) {
  var size = props.size,
      icon = props.icon,
      children = props.children,
      style = props.style,
      letter = props.letter,
      image = props.image,
      _props$alt = props.alt,
      alt = _props$alt === undefined ? '' : _props$alt,
      className = props.className;

  var avatarClass = classNames('a-avatar', _defineProperty$3({}, '' + sizeClasses$1[size], !!size), className);

  return React.createElement('div', { className: avatarClass, style: style }, icon && React.createElement(IconWrapper, { icon: icon }), letter && React.createElement(LetterWrapper, { letter: letter }), image && React.createElement('img', { src: image, alt: alt }), children);
};

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var typeClasses$2 = {
  primary: 'a-badge--primary',
  secondary: 'a-badge--secondary',
  success: 'a-badge--success',
  warning: 'a-badge--warning',
  danger: 'a-badge--danger'
};

var Badge = function Badge(props) {
  var type = props.type,
      className = props.className,
      _props$style = props.style,
      style = _props$style === undefined ? {} : _props$style,
      children = props.children;

  var badgeClass = classNames('a-badge', className, _defineProperty$4({}, '' + typeClasses$2[type], !!type));

  return React.createElement('span', { className: badgeClass, style: style }, children);
};

var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Icon$3 = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

var _createClass$3 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$3(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$2(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses$2 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$3 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent'
};

var Button$1 = function (_Component) {
  _inherits$3(Button, _Component);

  function Button() {
    _classCallCheck$3(this, Button);

    return _possibleConstructorReturn$3(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass$3(Button, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          negative = _props.negative,
          outline = _props.outline,
          transparent = _props.transparent,
          className = _props.className,
          children = _props.children,
          icon = _props.icon,
          iconLeft = _props.iconLeft,
          iconRight = _props.iconRight,
          onClick = _props.onClick,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          type = _props.type,
          size = _props.size,
          _props$block = _props.block,
          block = _props$block === undefined ? false : _props$block,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          htmlType = _props.htmlType;

      var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty$5(_classNames, '' + typeClasses$3[type], !!type), _defineProperty$5(_classNames, '' + sizeClasses$2[size], !!size), _defineProperty$5(_classNames, 'has-icon', !!icon), _defineProperty$5(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$5(_classNames, 'has-icon-right', !!iconRight), _defineProperty$5(_classNames, 'a-button-negative', !!negative), _defineProperty$5(_classNames, 'a-button-outline', !!outline), _defineProperty$5(_classNames, 'a-button--block', block), _classNames));

      return React.createElement('button', {
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType }, icon ? React.createElement(Icon$3, { name: icon }) : null, iconLeft ? React.createElement(Icon$3, { name: iconLeft }) : null, iconRight ? React.createElement(Icon$3, { name: iconRight }) : null, children);
    }
  }]);

  return Button;
}(Component);

var _typeof$3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function daysOfMonth(displayedMonth) {
	var _i = void 0,
	    d = void 0;
	var results = [];
	var startOfMonth = displayedMonth.startOf('months');
	var startDayOfWeek = startOfMonth.clone().startOf('isoWeek');
	var startAt = -startOfMonth.diff(startDayOfWeek, 'days');

	var endAt = Math.ceil((displayedMonth.daysInMonth() - startAt) / 7) * 7 + startAt - 1;
	for (d = _i = startAt; startAt <= endAt ? _i <= endAt : _i >= endAt; d = startAt <= endAt ? ++_i : --_i) {
		results.push(displayedMonth.clone().add(d, 'days'));
	}

	return results;
}

function weekEnum(daysOfMonth) {
	var results = [];

	for (var _i = 0, _ref = daysOfMonth.length / 7; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--) {
		results.push(_i);
	}
	return results;
}

function isDateFromNextMonth(date, displayedMonth) {
	return date.year() > displayedMonth.year() || date.year() === displayedMonth.year() && date.month() > displayedMonth.month();
}

function isDateFromPrevMonth(date, displayedMonth) {
	return date.year() < displayedMonth.year() || date.year() === displayedMonth.year() && date.month() < displayedMonth.month();
}

function yearsOfMonth(displayedMonth) {
	var amountOfYearsBack = -11;
	var results = [];

	for (var year = amountOfYearsBack; year < 0; year++) {
		results.push(displayedMonth.clone().add(year, 'years').format('YYYY'));
	}
	results.push(displayedMonth.clone().format('YYYY'));

	return results;
}

function nextItemInArray(element, array) {
	var i = array.findIndex(function (k) {
		return k == element;
	});
	i = i + 1;
	i = i % array.length;
	return array[i];
}

var Icon$4 = function Icon(props) {
	var name = props.name,
	    style = props.style,
	    span = props.span,
	    className = props.className;

	var iconClass = classNames(className, 'fa fa-' + name);

	if (span) {
		return React.createElement('span', { className: iconClass, style: style });
	} else {
		return React.createElement('i', { className: iconClass, style: style });
	}
};

var _createClass$4 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _defineProperty$6(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

function _classCallCheck$4(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$4(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$4(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses$3 = {
	tiny: 'a-button--tiny',
	small: 'a-button--small',
	large: 'a-button--large'
};
var typeClasses$4 = {
	primary: '',
	secondary: 'a-button--secondary',
	success: 'a-button--success',
	warning: 'a-button--warning',
	danger: 'a-button--danger',
	transparent: 'a-button--transparent'
};

var Button$2 = function (_Component) {
	_inherits$4(Button, _Component);

	function Button() {
		_classCallCheck$4(this, Button);

		return _possibleConstructorReturn$4(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	}

	_createClass$4(Button, [{
		key: 'render',
		value: function render() {
			var _classNames;

			var _props = this.props,
			    negative = _props.negative,
			    outline = _props.outline,
			    transparent = _props.transparent,
			    className = _props.className,
			    children = _props.children,
			    icon = _props.icon,
			    iconLeft = _props.iconLeft,
			    iconRight = _props.iconRight,
			    onClick = _props.onClick,
			    _props$title = _props.title,
			    title = _props$title === undefined ? '' : _props$title,
			    type = _props.type,
			    size = _props.size,
			    _props$block = _props.block,
			    block = _props$block === undefined ? false : _props$block,
			    _props$style = _props.style,
			    style = _props$style === undefined ? {} : _props$style,
			    _props$disabled = _props.disabled,
			    disabled = _props$disabled === undefined ? false : _props$disabled,
			    htmlType = _props.htmlType;

			var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty$6(_classNames, '' + typeClasses$4[type], !!type), _defineProperty$6(_classNames, '' + sizeClasses$3[size], !!size), _defineProperty$6(_classNames, 'has-icon', !!icon), _defineProperty$6(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$6(_classNames, 'has-icon-right', !!iconRight), _defineProperty$6(_classNames, 'a-button-negative', !!negative), _defineProperty$6(_classNames, 'a-button-outline', !!outline), _defineProperty$6(_classNames, 'a-button--block', block), _classNames));

			return React.createElement('button', {
				className: btnClass,
				title: title || '',
				onClick: onClick,
				style: style,
				disabled: disabled,
				type: htmlType }, icon ? React.createElement(Icon$4, { name: icon }) : null, iconLeft ? React.createElement(Icon$4, { name: iconLeft }) : null, iconRight ? React.createElement(Icon$4, { name: iconRight }) : null, children);
		}
	}]);

	return Button;
}(Component);

var _createClass$1$2 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$1$2(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$1$2(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$2(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Nav = function (_Component) {
	_inherits$1$2(Nav, _Component);

	function Nav() {
		_classCallCheck$1$2(this, Nav);

		return _possibleConstructorReturn$1$2(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	}

	_createClass$1$2(Nav, [{
		key: 'renderNav',
		value: function renderNav() {
			var _props = this.props,
			    viewType = _props.viewType,
			    displayedPeriod = _props.displayedPeriod;

			switch (viewType) {
				case 'months':
					return displayedPeriod.format('YYYY');
				case 'years':
					return this.renderYearsNav(displayedPeriod);
				default:
					return displayedPeriod.format('MMMM YYYY');
			}
		}
	}, {
		key: 'renderYearsNav',
		value: function renderYearsNav(displayedMonth) {
			var years = yearsOfMonth(displayedMonth);
			return years[0] + '-' + years.slice(-1);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    onClickPrevious = _props2.onClickPrevious,
			    onClickViewType = _props2.onClickViewType,
			    onClickNext = _props2.onClickNext;

			return React.createElement(React.Fragment, null, React.createElement(Button$2, {
				htmlType: 'button',
				onClick: onClickPrevious,
				className: "a-button has-icon",
				icon: "angle-left" }), React.createElement(Button$2, {
				htmlType: 'button',
				onClick: onClickViewType,
				className: "m-datepicker__title a-button" }, this.renderNav()), React.createElement(Button$2, {
				htmlType: 'button',
				onClick: onClickNext,
				className: "a-button has-icon",
				icon: "angle-right" }));
		}
	}]);

	return Nav;
}(Component);

var _createClass$2$2 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$2$2(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$2$2(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$2$2(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Rows = function (_Component) {
	_inherits$2$2(Rows, _Component);

	function Rows() {
		_classCallCheck$2$2(this, Rows);

		return _possibleConstructorReturn$2$2(this, (Rows.__proto__ || Object.getPrototypeOf(Rows)).apply(this, arguments));
	}

	_createClass$2$2(Rows, [{
		key: "generateRows",
		value: function generateRows() {
			var _props = this.props,
			    list = _props.list,
			    rowLength = _props.rowLength,
			    onClick = _props.onClick;

			return list.map(function (content, index) {
				return React.createElement("td", { key: index }, React.createElement("button", { tabIndex: index, value: content, onClick: onClick, type: "button" }, content));
			}).reduce(function (r, element, index) {
				// create element groups with size 4, result looks like:
				// [[elem1, elem2, elem3], [elem4, elem5, elem6],x ...]
				index % rowLength === 0 && r.push([]);
				r[r.length - 1].push(element);
				return r;
			}, []).map(function (rowContent, index) {
				// surround every group with a tr
				return React.createElement("tr", { key: index }, rowContent);
			});
		}
	}, {
		key: "render",
		value: function render() {
			return this.generateRows();
		}
	}]);

	return Rows;
}(Component);

var _createClass$3$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$3$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$3$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$3$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Day = function (_Component) {
	_inherits$3$1(Day, _Component);

	function Day() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$3$1(this, Day);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$3$1(this, (_ref = Day.__proto__ || Object.getPrototypeOf(Day)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (day) {
			var _this$props = _this.props,
			    disabled = _this$props.disabled,
			    selectDay = _this$props.selectDay;

			if (disabled) return;
			selectDay(day);
		}, _temp), _possibleConstructorReturn$3$1(_this, _ret);
	}

	_createClass$3$1(Day, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    activeDate = _props.activeDate,
			    day = _props.day,
			    selected = _props.selected,
			    disabled = _props.disabled,
			    dayNextMonth = _props.dayNextMonth,
			    dayPrevMonth = _props.dayPrevMonth,
			    dayActiveClassName = _props.dayActiveClassName,
			    selectedClassName = _props.selectedClassName,
			    dayDisabledClassName = _props.dayDisabledClassName,
			    dayFromOtherMonthClassName = _props.dayFromOtherMonthClassName;

			var buttonClasses = [];

			if (day.isSame(Moment(), 'day')) {
				buttonClasses.push(selectedClassName);
			}

			if (day.isSame(activeDate, 'day')) {
				buttonClasses.push(dayActiveClassName);
			}

			if (disabled) {
				buttonClasses.push(dayDisabledClassName);
			}

			if (selected) {
				buttonClasses.push(dayActiveClassName);
			}

			if (dayPrevMonth || dayNextMonth) {
				buttonClasses.push(dayFromOtherMonthClassName);
			}

			return React.createElement('td', null, React.createElement('button', {
				type: 'button',
				onClick: this.handleOnClick.bind(this, day),
				className: buttonClasses.join(' ') }, day.date()));
		}
	}]);

	return Day;
}(Component);

Day.defaultProps = {
	dayClassName: '',
	dayActiveClassName: 'is-selected',
	selectedClassName: 'is-current',
	dayDisabledClassName: 'is-unavailable',
	dayFromOtherMonthClassName: 'is-faded'
};

var _createClass$4$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$4$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$4$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$4$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Body = function (_Component) {
	_inherits$4$1(Body, _Component);

	function Body() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$4$1(this, Body);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$4$1(this, (_ref = Body.__proto__ || Object.getPrototypeOf(Body)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (type, event) {
			var value = event.target.value;
			var newDisplayedPeriod = null;
			var displayedPeriod = _this.props.displayedPeriod;

			if (type === 'days') {
				newDisplayedPeriod = Moment(displayedPeriod.format('YYYY') + value, "YYYY MMM");
			} else if (type === 'months') {
				newDisplayedPeriod = Moment(displayedPeriod.format('MM') + value, "MM YYYY");
			}

			var goToViewType = _this.props.goToViewType;

			goToViewType(type, newDisplayedPeriod);
		}, _temp), _possibleConstructorReturn$4$1(_this, _ret);
	}

	_createClass$4$1(Body, [{
		key: 'renderBody',
		value: function renderBody(displayedPeriod) {
			var viewType = this.props.viewType;

			switch (viewType) {
				case 'months':
					return this.renderListMonths();
				case "years":
					return this.renderListYears(displayedPeriod);
				default:
					return this.renderWeeks(displayedPeriod);
			}
		}
	}, {
		key: 'renderWeeks',
		value: function renderWeeks(displayMonth) {
			var _this2 = this;

			var _daysOfMonth = daysOfMonth(displayMonth);
			var _weekEnum = weekEnum(_daysOfMonth);
			return _weekEnum.map(function (week, key) {
				return React.createElement('tr', { key: key }, _this2.renderDay(_daysOfMonth, week));
			});
		}
	}, {
		key: 'renderListMonths',
		value: function renderListMonths() {
			var months = Moment.monthsShort();
			return React.createElement(Rows, { list: months, rowLength: 4, onClick: this.handleOnClick.bind(this, 'days') });
		}
	}, {
		key: 'renderListYears',
		value: function renderListYears(displayMonth) {
			var years = yearsOfMonth(displayMonth);
			return React.createElement(Rows, { list: years, rowLength: 4, onClick: this.handleOnClick.bind(this, 'months') });
		}
	}, {
		key: 'renderDay',
		value: function renderDay(_daysOfMonth, week) {
			var _this3 = this;

			var days = [0, 1, 2, 3, 4, 5, 6];
			var _props = this.props,
			    activeDate = _props.activeDate,
			    displayedPeriod = _props.displayedPeriod,
			    selectedDates = _props.selectedDates,
			    minDate = _props.minDate,
			    maxDate = _props.maxDate,
			    format = _props.format,
			    noWeekends = _props.noWeekends,
			    selectDay = _props.selectDay;

			return days.map(function (day, key) {
				var date = _daysOfMonth[week * 7 + day];
				var disabled = void 0;
				var selected = false;

				if (minDate && maxDate) {
					disabled = date.isBefore(minDate, 'day') || date.isAfter(maxDate, 'day');
				} else if (minDate) {
					disabled = date.isBefore(minDate, 'day');
				} else if (maxDate) {
					disabled = date.isAfter(maxDate, 'day');
				}

				if (noWeekends) {
					disabled = date.day() === 6 || date.day() === 0;
				}

				var dayNextMonth = isDateFromNextMonth(date, displayedPeriod);
				var dayPrevMonth = isDateFromPrevMonth(date, displayedPeriod);

				selectedDates.forEach(function (selectedDate) {
					if (date.isSame(Moment(selectedDate, format), 'day')) {
						selected = true;
						dayPrevMonth = false;
						dayNextMonth = false;
					}
				});

				return React.createElement(Day, {
					key: key,
					day: date,
					selectDay: selectDay.bind(_this3, date),
					disabled: disabled,
					selected: selected,
					dayPrevMonth: dayPrevMonth,
					dayNextMonth: dayNextMonth,
					activeDate: activeDate });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var displayedPeriod = this.props.displayedPeriod;

			return this.renderBody(displayedPeriod);
		}
	}]);

	return Body;
}(Component);

Body.defaultProps = {
	selectedDates: []
};

var _createClass$5 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$5(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$5(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$5(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Head = function (_Component) {
	_inherits$5(Head, _Component);

	function Head() {
		_classCallCheck$5(this, Head);

		return _possibleConstructorReturn$5(this, (Head.__proto__ || Object.getPrototypeOf(Head)).apply(this, arguments));
	}

	_createClass$5(Head, [{
		key: 'renderHeader',
		value: function renderHeader() {
			var viewType = this.props.viewType;

			switch (viewType) {
				case 'months':
					return null;
				case 'years':
					return null;
				default:
					return this.renderNameOfDays();
			}
		}
	}, {
		key: 'renderNameOfDays',
		value: function renderNameOfDays() {
			var nameOfDays = Moment.weekdaysShort();
			return React.createElement('tr', { className: 'm-datepicker__days' }, nameOfDays.map(function (day, i) {
				return React.createElement('th', { key: i }, day);
			}));
		}
	}, {
		key: 'render',
		value: function render() {
			return this.renderHeader();
		}
	}]);

	return Head;
}(Component);

var _createClass$6 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$6(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$6(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$6(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Calendar = function (_Component) {
	_inherits$6(Calendar, _Component);

	function Calendar() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$6(this, Calendar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$6(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			displayedPeriod: _this.props.activeDate ? Moment(_this.props.activeDate, _this.props.format) : Moment(),
			viewType: "days",
			views: ["days", "months", "years"]
		}, _temp), _possibleConstructorReturn$6(_this, _ret);
	}

	_createClass$6(Calendar, [{
		key: 'changeViewType',
		value: function changeViewType() {
			var _state = this.state,
			    viewType = _state.viewType,
			    views = _state.views;

			var switchTo = nextItemInArray(viewType, views);
			this.goToViewType(switchTo);
		}
	}, {
		key: 'goToViewType',
		value: function goToViewType(switchTo) {
			var displayedPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

			this.setState({
				viewType: switchTo,
				displayedPeriod: displayedPeriod || this.state.displayedPeriod
			});
		}
	}, {
		key: 'moveDisplayedPeriod',
		value: function moveDisplayedPeriod(delta) {
			var _state2 = this.state,
			    viewType = _state2.viewType,
			    displayedPeriod = _state2.displayedPeriod;

			var period = viewType === 'days' ? 'months' : 'years';

			this.setState({
				displayedPeriod: displayedPeriod.clone().add(delta, period)
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    selectDay = _props.selectDay,
			    activeDate = _props.activeDate,
			    selectedDates = _props.selectedDates,
			    minDate = _props.minDate,
			    maxDate = _props.maxDate,
			    format = _props.format,
			    noWeekends = _props.noWeekends;
			var _state3 = this.state,
			    viewType = _state3.viewType,
			    displayedPeriod = _state3.displayedPeriod;

			return React.createElement(React.Fragment, null, React.createElement('div', { className: 'm-datepicker__nav' }, React.createElement(Nav, {
				viewType: viewType,
				displayedPeriod: displayedPeriod,
				onClickPrevious: this.moveDisplayedPeriod.bind(this, -1),
				onClickViewType: this.changeViewType.bind(this),
				onClickNext: this.moveDisplayedPeriod.bind(this, 1)
			})), React.createElement('table', { cellPadding: '0', cellSpacing: '0' }, React.createElement('thead', null, React.createElement(Head, {
				displayedPeriod: displayedPeriod,
				viewType: viewType
			})), React.createElement('tbody', { className: 'm-datepicker__calendar' }, React.createElement(Body, {
				viewType: viewType,
				displayedPeriod: displayedPeriod,
				selectDay: selectDay.bind(this),
				selectedDates: selectedDates,
				minDate: minDate,
				maxDate: maxDate,
				format: format,
				noWeekends: noWeekends,
				activeDate: activeDate,
				goToViewType: this.goToViewType.bind(this)
			}))));
		}
	}]);

	return Calendar;
}(Component);

var _createClass$7 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$7(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$7(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$7(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DatePicker = function (_Component) {
	_inherits$7(DatePicker, _Component);

	function DatePicker() {
		_classCallCheck$7(this, DatePicker);

		return _possibleConstructorReturn$7(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
	}

	_createClass$7(DatePicker, [{
		key: 'renderCalendar',
		value: function renderCalendar() {
			var _props = this.props,
			    activeDate = _props.activeDate,
			    minDate = _props.minDate,
			    maxDate = _props.maxDate,
			    format = _props.format,
			    selectedDates = _props.selectedDates,
			    noWeekends = _props.noWeekends,
			    clickOnDate = _props.clickOnDate;

			return React.createElement(Calendar, {
				activeDate: activeDate,
				minDate: minDate,
				maxDate: maxDate,
				format: format,
				selectedDates: selectedDates,
				noWeekends: noWeekends,
				selectDay: clickOnDate.bind(this) });
		}
	}, {
		key: 'render',
		value: function render() {
			return this.renderCalendar();
		}
	}]);

	return DatePicker;
}(Component);

var _createClass$8 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$8(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$8(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$3(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$8(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$3(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Calendar$1 = function (_Component) {
	_inherits$8(Calendar, _Component);

	function Calendar(props) {
		_classCallCheck$8(this, Calendar);

		var _this = _possibleConstructorReturn$8(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

		var _this$props = _this.props,
		    activeDate = _this$props.activeDate,
		    format = _this$props.format;

		Moment.updateLocale('nl', {
			months: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
			weekdaysShort: ["Ma", "Di", "Woe", "Do", "Vr", "Za", "Zo"]
		});

		_this.state = {
			activeDate: activeDate ? Moment(activeDate, format) : ''
		};
		return _this;
	}

	_createClass$8(Calendar, [{
		key: 'changeDate',
		value: function changeDate(day) {
			var _props = this.props,
			    onChange = _props.onChange,
			    format = _props.format;

			if (onChange) onChange(Moment(day).format(format));

			this.setState({
				activeDate: day
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    format = _props2.format,
			    selectedDates = _props2.selectedDates,
			    minDate = _props2.minDate,
			    maxDate = _props2.maxDate,
			    noWeekends = _props2.noWeekends;
			var activeDate = this.state.activeDate;

			return React.createElement('div', { className: 'm-datepicker is-open' }, React.createElement(DatePicker, {
				format: format,
				activeDate: activeDate,
				selectedDates: selectedDates,
				minDate: Moment(minDate, format),
				maxDate: Moment(maxDate, format),
				noWeekends: noWeekends,
				clickOnDate: this.changeDate.bind(this)
			}));
		}
	}], [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(nextProps, prevState) {
			if (nextProps.activeDate) {
				return {
					activeDate: Moment(nextProps.activeDate, nextProps.format)
				};
			}
			return null;
		}
	}]);

	return Calendar;
}(Component);

Calendar$1.defaultProps = {
	format: 'DD/MM/YYYY',
	noWeekends: false
};

var _typeof$4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass$9 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$9(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$4(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$4(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Card = function (_Component) {
  _inherits$9(Card, _Component);

  function Card() {
    _classCallCheck$9(this, Card);

    return _possibleConstructorReturn$9(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
  }

  _createClass$9(Card, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          children = _props.children;

      var cardClass = classNames('m-card', className);

      return React.createElement('div', { className: cardClass, style: style }, children);
    }
  }]);

  return Card;
}(Component);

var Contact = function Contact(props) {
  var name = props.name,
      avatar = props.avatar,
      style = props.style,
      info = props.info;

  return React.createElement("div", { className: "m-contact", style: style }, avatar, React.createElement("div", { className: "m-contact__info" }, React.createElement("p", { className: "u-text-bold" }, name), info && React.createElement("p", { className: "small" }, info)));
};

var CardHeader = function CardHeader(props) {
  var title = props.title,
      actions = props.actions,
      avatar = props.avatar;

  var cardHeader = React.createElement('div', { className: 'm-card__header', style: { display: 'flex' } }, React.createElement(Contact, {
    avatar: avatar,
    name: title,
    style: { flex: 1, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' } }), React.createElement('div', { style: { float: 'right', textAlign: 'right' } }, actions));

  return title || actions ? cardHeader : null;
};

var CardBody = function CardBody(props) {
  var children = props.children,
      style = props.style;

  return React.createElement("div", { className: "m-card__body", style: style }, children);
};

var CardTitle = function CardTitle(props) {
  var children = props.children,
      style = props.style;

  return React.createElement("h5", { className: "u-margin-bottom-xs", style: style }, children);
};

var CardDescription = function CardDescription(props) {
  var children = props.children,
      style = props.style;

  return React.createElement('p', { style: style }, children);
};

var CardActions = function CardActions(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement('div', { className: classNames('pull-right u-margin-bottom-xs', className) }, children);
};

CardActions.defaultProps = {
  className: ''
};

var CardIcon = function CardIcon(_ref) {
  var icon = _ref.icon,
      className = _ref.className;
  return React.createElement('div', { className: classNames('pull-left u-margin-right u-margin-bottom', className) }, React.createElement('i', { className: classNames('fa fa-lg u-text-light', icon) }));
};

CardIcon.defaultProps = {
  className: ''
};

var CardImage = function CardImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      className = _ref.className;
  return React.createElement('div', { className: classNames('pull-left u-margin-right', className) }, React.createElement('div', { className: 'a-avatar a-avatar--small' }, React.createElement('img', { src: src, alt: alt })));
};

CardImage.defaultProps = {
  className: '',
  alt: 'Default Alt'
};

var Contact$1 = function Contact(props) {
  var name = props.name,
      avatar = props.avatar,
      style = props.style,
      info = props.info;

  return React.createElement("div", { className: "m-contact", style: style }, avatar, React.createElement("div", { className: "m-contact__info" }, React.createElement("p", { className: "u-text-bold" }, name), info && React.createElement("p", { className: "small" }, info)));
};

var Content = function Content(props) {
  var className = props.className,
      children = props.children;

  var contentClass = classNames('u-wrapper', className);
  return React.createElement('div', { className: contentClass }, React.createElement('div', { className: 'u-container' }, children));
};

var _typeof$5 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var FlyoutContent$1 = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children;

  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });

  return React.createElement('div', { className: classes }, children);
};

var _createClass$a = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$a(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$5(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$5(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var flyoutSizes$1 = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var Flyout$1 = function (_Component) {
  _inherits$a(Flyout, _Component);

  function Flyout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$a(this, Flyout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$a(this, (_ref = Flyout.__proto__ || Object.getPrototypeOf(Flyout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: _this.props.open
    }, _this.flyoutRef = React.createRef(), _this.toggleIsOpen = function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }
      _this.setState({ isOpen: !_this.state.isOpen });
      onStateChange(_this.state.isOpen);
    }, _this.closeFlyout = function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }
      _this.setState({ isOpen: false });
      onStateChange(false);
    }, _this.handleOutsideClick = function (e) {
      var area = ReactDOM.findDOMNode(_this.flyoutRef.current);
      if (area && !area.contains(e.target)) {
        _this.closeFlyout();
      }
    }, _this.getClassNames = function () {
      return classNames(_this.props.className, 'm-flyout', 'm-flyout--' + _this.props.direction, _defineProperty$7({
        'is-open': _this.state.isOpen,
        'm-flyout--scrollable': _this.props.scrollable
      }, 'm-flyout--' + flyoutSizes$1[_this.props.size], !!flyoutSizes$1[_this.props.size]));
    }, _temp), _possibleConstructorReturn$a(_this, _ret);
  }

  _createClass$a(Flyout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isOpen = this.state.isOpen;

      if (isOpen) {
        document.addEventListener('click', this.handleOutsideClick, false);
      }

      this.props.triggerClose(this.closeFlyout);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({ isOpen: !prevProps.open });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          hasPadding = _props.hasPadding,
          children = _props.children;

      var flyoutClass = this.getClassNames();
      return trigger && React.createElement('div', { className: flyoutClass, ref: this.flyoutRef }, React.createElement('div', { onClick: this.toggleIsOpen }, this.props.trigger), React.createElement(FlyoutContent$1, { hasPadding: hasPadding }, children));
    }
  }]);

  return Flyout;
}(Component);

Flyout$1.defaultProps = {
  direction: 'left',
  size: 'medium',
  hasPadding: false,
  open: false,
  onStateChange: function onStateChange() {},
  triggerClose: function triggerClose() {},
  scrollable: false
};

var _typeof$6 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Icon$5 = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

var _createClass$b = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$b(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$6(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$6(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses$4 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$5 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent'
};

var Button$3 = function (_Component) {
  _inherits$b(Button, _Component);

  function Button() {
    _classCallCheck$b(this, Button);

    return _possibleConstructorReturn$b(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass$b(Button, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          negative = _props.negative,
          outline = _props.outline,
          transparent = _props.transparent,
          className = _props.className,
          children = _props.children,
          icon = _props.icon,
          iconLeft = _props.iconLeft,
          iconRight = _props.iconRight,
          onClick = _props.onClick,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          type = _props.type,
          size = _props.size,
          _props$block = _props.block,
          block = _props$block === undefined ? false : _props$block,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          htmlType = _props.htmlType;

      var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty$8(_classNames, '' + typeClasses$5[type], !!type), _defineProperty$8(_classNames, '' + sizeClasses$4[size], !!size), _defineProperty$8(_classNames, 'has-icon', !!icon), _defineProperty$8(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$8(_classNames, 'has-icon-right', !!iconRight), _defineProperty$8(_classNames, 'a-button-negative', !!negative), _defineProperty$8(_classNames, 'a-button-outline', !!outline), _defineProperty$8(_classNames, 'a-button--block', block), _classNames));

      return React.createElement('button', {
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType }, icon ? React.createElement(Icon$5, { name: icon }) : null, iconLeft ? React.createElement(Icon$5, { name: iconLeft }) : null, iconRight ? React.createElement(Icon$5, { name: iconRight }) : null, children);
    }
  }]);

  return Button;
}(Component);

var FlyoutContent$2 = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children;

  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });

  return React.createElement('div', { className: classes }, children);
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass$1$3 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _defineProperty$1$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$1$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1$3(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$6(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$6(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var flyoutSizes$2 = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var FlyoutButton = function (_Component) {
  _inherits$1$3(FlyoutButton, _Component);

  function FlyoutButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1$3(this, FlyoutButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1$3(this, (_ref = FlyoutButton.__proto__ || Object.getPrototypeOf(FlyoutButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.handleClick = function (event) {
      if (_this.containerRef && !_this.containerRef.contains(event.target)) {
        _this.close();
      }
    }, _this.close = function () {
      return _this.setState({ isOpen: false });
    }, _this.toggleIsOpen = function () {
      return _this.setState({ isOpen: !_this.state.isOpen });
    }, _this.componentDidMount = function () {
      return document.addEventListener('mousedown', _this.handleClick);
    }, _this.componentWillUnMount = function () {
      return document.removeEventListener('mousedown', _this.handleClick);
    }, _this.getClassNames = function () {
      return classNames('m-flyout', 'm-flyout--' + _this.props.flyoutDirection, _defineProperty$1$1({
        'is-open': _this.state.isOpen
      }, 'm-flyout--' + flyoutSizes$2[_this.props.flyoutSize], !!flyoutSizes$2[_this.props.flyoutSize]));
    }, _temp), _possibleConstructorReturn$1$3(_this, _ret);
  }

  _createClass$1$3(FlyoutButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          flyoutHasPadding = _props.flyoutHasPadding,
          children = _props.children,
          buttonProps = _objectWithoutProperties$1(_props, ['label', 'flyoutHasPadding', 'children']);

      var flyoutClass = this.getClassNames();
      return React.createElement('div', { className: flyoutClass, ref: function ref(_ref2) {
          _this2.containerRef = _ref2;
        } }, React.createElement(Button$3, _extends$1({}, buttonProps, { onClick: this.toggleIsOpen }), label), React.createElement(FlyoutContent$2, { hasPadding: flyoutHasPadding }, this.props.children));
    }
  }]);

  return FlyoutButton;
}(Component);

FlyoutButton.defaultProps = {
  label: '',
  flyoutDirection: 'left',
  flyoutSize: 'medium',
  flyoutHasPadding: false,
  icon: false
};

var Footer = function Footer(props) {
  var style = props.style,
      children = props.children;

  return React.createElement("footer", { className: "o-footer", style: style }, React.createElement("span", { className: "o-footer__label" }, children || '© 2018 Stad Antwerpen'), React.createElement("a", { href: "/", className: "o-footer__button a-button a-button--secondary has-icon" }, React.createElement("i", { className: "fa fa-arrow-up" })));
};

var _typeof$7 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Form = function Form(props) {
	var children = props.children,
	    style = props.style,
	    onSubmit = props.onSubmit;

	return React.createElement("form", { className: "a-form", style: style, onSubmit: onSubmit }, children);
};

var Fielset = function Fielset(props) {
	var legend = props.legend,
	    children = props.children,
	    style = props.style;

	return React.createElement('fieldset', { style: style }, React.createElement('legend', null, legend), children);
};

var InputLabel$1 = function InputLabel(props) {
	var style = props.style,
	    htmlFor = props.htmlFor,
	    children = props.children,
	    inline = props.inline;

	var labelClass = classNames('a-input__label', {
		'a-input__label--inline': !!inline
	});
	return React.createElement('label', { className: labelClass, htmlFor: htmlFor, style: style }, children);
};

var Icon$6 = function Icon(props) {
	var name = props.name,
	    style = props.style,
	    span = props.span,
	    className = props.className;

	var iconClass = classNames(className, 'fa fa-' + name);

	if (span) {
		return React.createElement('span', { className: iconClass, style: style });
	} else {
		return React.createElement('i', { className: iconClass, style: style });
	}
};

var _extends$2 = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _createClass$c = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _defineProperty$1$2(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

function _objectWithoutProperties$2(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck$c(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$c(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$c(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var stateClasses$1 = {
	success: 'has-success',
	warning: 'has-warning',
	error: 'has-error'
};

var TextField$1 = function (_Component) {
	_inherits$c(TextField, _Component);

	function TextField() {
		_classCallCheck$c(this, TextField);

		return _possibleConstructorReturn$c(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).apply(this, arguments));
	}

	_createClass$c(TextField, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    label = _props.label,
			    value = _props.value,
			    name = _props.name,
			    description = _props.description,
			    required = _props.required,
			    placeholder = _props.placeholder,
			    onChange = _props.onChange,
			    onClick = _props.onClick,
			    onBlur = _props.onBlur,
			    onKeyDown = _props.onKeyDown,
			    mask = _props.mask,
			    state = _props.state,
			    autoComplete = _props.autoComplete,
			    disabled = _props.disabled,
			    iconright = _props.iconright,
			    iconleft = _props.iconleft;

			var _props2 = this.props,
			    loading = _props2.loading,
			    extraProps = _objectWithoutProperties$2(_props2, ['loading']);

			var inputClass = classNames('a-input', _defineProperty$1$2({
				'has-icon-right': iconright || loading,
				'has-icon-left': iconleft,
				'is-required': !!required
			}, '' + stateClasses$1[state], !!state));

			return React.createElement('div', { className: inputClass }, label && React.createElement(InputLabel$1, { htmlFor: id }, label), React.createElement('div', { className: 'a-input__wrapper' }, iconleft ? React.createElement(Icon$6, { name: iconleft }) : null, mask ? React.createElement(InputMask, this.props) : React.createElement('input', _extends$2({ type: 'text', autoComplete: autoComplete, disabled: disabled }, extraProps)), iconright ? React.createElement(Icon$6, { name: iconright }) : null, loading ? React.createElement('span', { className: 'fa a-spinner a-spinner--sm' }) : null), React.createElement('small', null, description));
		}
	}]);

	return TextField;
}(Component);

var _createClass$1$4 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$1$4(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$1$4(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$4(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Checkbox = function (_Component) {
	_inherits$1$4(Checkbox, _Component);

	function Checkbox() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$1$4(this, Checkbox);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$1$4(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
			if (_this.props.onChange) {
				_this.props.onChange(e);
			}
		}, _temp), _possibleConstructorReturn$1$4(_this, _ret);
	}

	_createClass$1$4(Checkbox, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    label = _props.label,
			    name = _props.name,
			    _props$checked = _props.checked,
			    checked = _props$checked === undefined ? false : _props$checked,
			    required = _props.required,
			    _props$disabled = _props.disabled,
			    disabled = _props$disabled === undefined ? false : _props$disabled;

			var inputClass = classNames('a-input');

			var requiredLabel = !!required ? React.createElement('span', { className: 'u-text-danger' }, ' *') : null;

			return React.createElement('div', { className: inputClass }, React.createElement('div', { className: 'a-input__checkbox' }, React.createElement('input', { type: 'checkbox', id: id, name: name, onChange: this.handleChange, checked: checked, disabled: disabled }), React.createElement(InputLabel$1, { htmlFor: id }, label, requiredLabel)));
		}
	}]);

	return Checkbox;
}(Component);

var Option = function Option(props) {
	var value = props.value,
	    disabled = props.disabled,
	    children = props.children;

	return React.createElement('option', { value: value, disabled: disabled }, children);
};

var Icon$1$1 = function Icon(props) {
	var name = props.name,
	    style = props.style,
	    span = props.span,
	    className = props.className;

	var iconClass = classNames(className, 'fa fa-' + name);

	if (span) {
		return React.createElement('span', { className: iconClass, style: style });
	} else {
		return React.createElement('i', { className: iconClass, style: style });
	}
};

function _defineProperty$2$2(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

var spinnerSizes$1 = {
	small: 'sm',
	large: 'lg'
};

var Spinner$1 = function Spinner(props) {
	var size = props.size,
	    style = props.style,
	    className = props.className;

	var spinnerClass = classNames('a-spinner', className, _defineProperty$2$2({}, 'a-spinner--' + spinnerSizes$1[size], !!size));

	return React.createElement('div', { className: spinnerClass, style: style });
};

var _createClass$2$3 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$2$3(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$2$3(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$2$3(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Select = function (_Component) {
	_inherits$2$3(Select, _Component);

	function Select(props) {
		_classCallCheck$2$3(this, Select);

		var _this = _possibleConstructorReturn$2$3(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		_this.state = {};
		return _this;
	}

	_createClass$2$3(Select, [{
		key: 'onChange',
		value: function onChange(e) {
			var value = e.currentTarget.value;
			this.setState({ value: value });

			if (this.props.onChange) {
				this.props.onChange(e);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    id = _props.id,
			    label = _props.label,
			    name = _props.name,
			    inline = _props.inline,
			    className = _props.className,
			    style = _props.style,
			    required = _props.required,
			    placeholder = _props.placeholder,
			    options = _props.options,
			    onChange = _props.onChange,
			    value = _props.value,
			    loading = _props.loading;

			var selectClass = classNames('a-input', 'has-icon-right', {
				'a-input--inline': !!inline,
				'is-required': !!required
			}, className);
			var wrapperClass = classNames('a-input__wrapper', {
				'a-input__wrapper--inline': !!inline
			});
			return React.createElement('div', { className: selectClass, name: name }, label && React.createElement(InputLabel$1, { inline: inline, htmlFor: id }, label), React.createElement('div', { className: wrapperClass }, React.createElement('select', { id: id, name: name, onChange: function onChange(e) {
					return _this2.onChange(e);
				}, value: value, defaultValue: placeholder }, placeholder && React.createElement('option', { value: placeholder, disabled: true }, placeholder), options.map(function (option) {
				return React.createElement(Option, {
					value: option.value,
					key: option.value,
					id: option.value,
					name: name,
					disabled: option.disabled }, option.label);
			})), loading ? React.createElement(Spinner$1, { size: 'small', className: 'fa' }) : React.createElement(Icon$1$1, { name: 'angle-down', span: true })));
		}
	}]);

	return Select;
}(Component);

function _defineProperty$3$1(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

var stateClasses$1$1 = {
	success: 'has-success',
	warning: 'has-warning',
	error: 'has-error'
};

var Textarea = function Textarea(props) {
	var id = props.id,
	    label = props.label,
	    value = props.value,
	    name = props.name,
	    disabled = props.disabled,
	    placeholder = props.placeholder,
	    className = props.className,
	    style = props.style,
	    required = props.required,
	    onChange = props.onChange,
	    onBlur = props.onBlur,
	    state = props.state;

	var textareaClass = classNames('a-input', _defineProperty$3$1({
		'is-required': !!required
	}, '' + stateClasses$1$1[state], !!state), className);

	return React.createElement('div', { className: textareaClass, style: style }, label && React.createElement(InputLabel$1, { htmlFor: id }, label), React.createElement('textarea', { id: id, placeholder: placeholder, name: name, value: value, onChange: onChange, onBlur: onBlur, disabled: disabled }));
};

var Radio = function Radio(props) {
	var id = props.id,
	    name = props.name,
	    value = props.value,
	    checked = props.checked,
	    children = props.children,
	    disabled = props.disabled,
	    required = props.required;

	var radioClass = classNames('a-input__radio');
	return React.createElement('div', { className: radioClass }, React.createElement('input', { type: 'radio', value: value, id: id, name: name, defaultChecked: checked, disabled: disabled, required: required }), React.createElement('label', { htmlFor: id }, children));
};

var RadioGroup = function RadioGroup(props) {
	var id = props.id,
	    name = props.name,
	    label = props.label,
	    value = props.value,
	    className = props.className,
	    description = props.description,
	    style = props.style,
	    required = props.required,
	    onChange = props.onChange,
	    inline = props.inline,
	    options = props.options;

	var radioGroupClass = classNames('a-input', className, {
		'is-required': !!required
	});
	return React.createElement('div', { className: radioGroupClass, style: style, onChange: onChange }, label && React.createElement(InputLabel$1, { inline: inline, htmlFor: id }, label), React.createElement('div', { className: 'a-input__wrapper' }, options.map(function (option, index) {
		return React.createElement(Radio, {
			value: option.value,
			key: option.value,
			id: option.value,
			name: name,
			disabled: option.disabled,
			checked: value === option.value,
			required: required }, option.label);
	})), React.createElement('small', null, description));
};

function daysOfMonth$1(displayedMonth) {
	var _i = void 0,
	    d = void 0;
	var results = [];
	var startOfMonth = displayedMonth.startOf('months');
	var startDayOfWeek = startOfMonth.clone().startOf('isoWeek');
	var startAt = -startOfMonth.diff(startDayOfWeek, 'days');

	var endAt = Math.ceil((displayedMonth.daysInMonth() - startAt) / 7) * 7 + startAt - 1;
	for (d = _i = startAt; startAt <= endAt ? _i <= endAt : _i >= endAt; d = startAt <= endAt ? ++_i : --_i) {
		results.push(displayedMonth.clone().add(d, 'days'));
	}

	return results;
}

function weekEnum$1(daysOfMonth) {
	var results = [];

	for (var _i = 0, _ref = daysOfMonth.length / 7; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--) {
		results.push(_i);
	}
	return results;
}

function isDateFromNextMonth$1(date, displayedMonth) {
	return date.year() > displayedMonth.year() || date.year() === displayedMonth.year() && date.month() > displayedMonth.month();
}

function isDateFromPrevMonth$1(date, displayedMonth) {
	return date.year() < displayedMonth.year() || date.year() === displayedMonth.year() && date.month() < displayedMonth.month();
}

function yearsOfMonth$1(displayedMonth) {
	var amountOfYearsBack = -11;
	var results = [];

	for (var year = amountOfYearsBack; year < 0; year++) {
		results.push(displayedMonth.clone().add(year, 'years').format('YYYY'));
	}
	results.push(displayedMonth.clone().format('YYYY'));

	return results;
}

function nextItemInArray$1(element, array) {
	var i = array.findIndex(function (k) {
		return k == element;
	});
	i = i + 1;
	i = i % array.length;
	return array[i];
}

var _createClass$3$2 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _defineProperty$4$1(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

function _classCallCheck$3$2(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$3$2(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$3$2(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses$5 = {
	tiny: 'a-button--tiny',
	small: 'a-button--small',
	large: 'a-button--large'
};
var typeClasses$6 = {
	primary: '',
	secondary: 'a-button--secondary',
	success: 'a-button--success',
	warning: 'a-button--warning',
	danger: 'a-button--danger',
	transparent: 'a-button--transparent'
};

var Button$4 = function (_Component) {
	_inherits$3$2(Button, _Component);

	function Button() {
		_classCallCheck$3$2(this, Button);

		return _possibleConstructorReturn$3$2(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	}

	_createClass$3$2(Button, [{
		key: 'render',
		value: function render() {
			var _classNames;

			var _props = this.props,
			    negative = _props.negative,
			    outline = _props.outline,
			    transparent = _props.transparent,
			    className = _props.className,
			    children = _props.children,
			    icon = _props.icon,
			    iconLeft = _props.iconLeft,
			    iconRight = _props.iconRight,
			    onClick = _props.onClick,
			    _props$title = _props.title,
			    title = _props$title === undefined ? '' : _props$title,
			    type = _props.type,
			    size = _props.size,
			    _props$block = _props.block,
			    block = _props$block === undefined ? false : _props$block,
			    _props$style = _props.style,
			    style = _props$style === undefined ? {} : _props$style,
			    _props$disabled = _props.disabled,
			    disabled = _props$disabled === undefined ? false : _props$disabled,
			    htmlType = _props.htmlType;

			var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty$4$1(_classNames, '' + typeClasses$6[type], !!type), _defineProperty$4$1(_classNames, '' + sizeClasses$5[size], !!size), _defineProperty$4$1(_classNames, 'has-icon', !!icon), _defineProperty$4$1(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$4$1(_classNames, 'has-icon-right', !!iconRight), _defineProperty$4$1(_classNames, 'a-button-negative', !!negative), _defineProperty$4$1(_classNames, 'a-button-outline', !!outline), _defineProperty$4$1(_classNames, 'a-button--block', block), _classNames));

			return React.createElement('button', {
				className: btnClass,
				title: title || '',
				onClick: onClick,
				style: style,
				disabled: disabled,
				type: htmlType }, icon ? React.createElement(Icon$1$1, { name: icon }) : null, iconLeft ? React.createElement(Icon$1$1, { name: iconLeft }) : null, iconRight ? React.createElement(Icon$1$1, { name: iconRight }) : null, children);
		}
	}]);

	return Button;
}(Component);

var _createClass$4$2 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$4$2(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$4$2(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$4$2(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Nav$1 = function (_Component) {
	_inherits$4$2(Nav, _Component);

	function Nav() {
		_classCallCheck$4$2(this, Nav);

		return _possibleConstructorReturn$4$2(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	}

	_createClass$4$2(Nav, [{
		key: 'renderNav',
		value: function renderNav() {
			var _props = this.props,
			    viewType = _props.viewType,
			    displayedPeriod = _props.displayedPeriod;

			switch (viewType) {
				case 'months':
					return displayedPeriod.format('YYYY');
				case 'years':
					return this.renderYearsNav(displayedPeriod);
				default:
					return displayedPeriod.format('MMMM YYYY');
			}
		}
	}, {
		key: 'renderYearsNav',
		value: function renderYearsNav(displayedMonth) {
			var years = yearsOfMonth$1(displayedMonth);
			return years[0] + '-' + years.slice(-1);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    onClickPrevious = _props2.onClickPrevious,
			    onClickViewType = _props2.onClickViewType,
			    onClickNext = _props2.onClickNext;

			return React.createElement(React.Fragment, null, React.createElement(Button$4, {
				htmlType: 'button',
				onClick: onClickPrevious,
				className: "a-button has-icon",
				icon: "angle-left" }), React.createElement(Button$4, {
				htmlType: 'button',
				onClick: onClickViewType,
				className: "m-datepicker__title a-button" }, this.renderNav()), React.createElement(Button$4, {
				htmlType: 'button',
				onClick: onClickNext,
				className: "a-button has-icon",
				icon: "angle-right" }));
		}
	}]);

	return Nav;
}(Component);

var _createClass$5$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$5$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$5$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$5$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Rows$1 = function (_Component) {
	_inherits$5$1(Rows, _Component);

	function Rows() {
		_classCallCheck$5$1(this, Rows);

		return _possibleConstructorReturn$5$1(this, (Rows.__proto__ || Object.getPrototypeOf(Rows)).apply(this, arguments));
	}

	_createClass$5$1(Rows, [{
		key: "generateRows",
		value: function generateRows() {
			var _props = this.props,
			    list = _props.list,
			    rowLength = _props.rowLength,
			    onClick = _props.onClick;

			return list.map(function (content, index) {
				return React.createElement("td", { key: index }, React.createElement("button", { tabIndex: index, value: content, onClick: onClick, type: "button" }, content));
			}).reduce(function (r, element, index) {
				// create element groups with size 4, result looks like:
				// [[elem1, elem2, elem3], [elem4, elem5, elem6],x ...]
				index % rowLength === 0 && r.push([]);
				r[r.length - 1].push(element);
				return r;
			}, []).map(function (rowContent, index) {
				// surround every group with a tr
				return React.createElement("tr", { key: index }, rowContent);
			});
		}
	}, {
		key: "render",
		value: function render() {
			return this.generateRows();
		}
	}]);

	return Rows;
}(Component);

var _createClass$6$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$6$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$6$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$6$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Day$1 = function (_Component) {
	_inherits$6$1(Day, _Component);

	function Day() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$6$1(this, Day);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$6$1(this, (_ref = Day.__proto__ || Object.getPrototypeOf(Day)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (day) {
			var _this$props = _this.props,
			    disabled = _this$props.disabled,
			    selectDay = _this$props.selectDay;

			if (disabled) return;
			selectDay(day);
		}, _temp), _possibleConstructorReturn$6$1(_this, _ret);
	}

	_createClass$6$1(Day, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    activeDate = _props.activeDate,
			    day = _props.day,
			    selected = _props.selected,
			    disabled = _props.disabled,
			    dayNextMonth = _props.dayNextMonth,
			    dayPrevMonth = _props.dayPrevMonth,
			    dayActiveClassName = _props.dayActiveClassName,
			    selectedClassName = _props.selectedClassName,
			    dayDisabledClassName = _props.dayDisabledClassName,
			    dayFromOtherMonthClassName = _props.dayFromOtherMonthClassName;

			var buttonClasses = [];

			if (day.isSame(Moment(), 'day')) {
				buttonClasses.push(selectedClassName);
			}

			if (day.isSame(activeDate, 'day')) {
				buttonClasses.push(dayActiveClassName);
			}

			if (disabled) {
				buttonClasses.push(dayDisabledClassName);
			}

			if (selected) {
				buttonClasses.push(dayActiveClassName);
			}

			if (dayPrevMonth || dayNextMonth) {
				buttonClasses.push(dayFromOtherMonthClassName);
			}

			return React.createElement('td', null, React.createElement('button', {
				type: 'button',
				onClick: this.handleOnClick.bind(this, day),
				className: buttonClasses.join(' ') }, day.date()));
		}
	}]);

	return Day;
}(Component);

Day$1.defaultProps = {
	dayClassName: '',
	dayActiveClassName: 'is-selected',
	selectedClassName: 'is-current',
	dayDisabledClassName: 'is-unavailable',
	dayFromOtherMonthClassName: 'is-faded'
};

var _createClass$7$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$7$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$7$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$7$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Body$1 = function (_Component) {
	_inherits$7$1(Body, _Component);

	function Body() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$7$1(this, Body);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$7$1(this, (_ref = Body.__proto__ || Object.getPrototypeOf(Body)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (type, event) {
			var value = event.target.value;
			var newDisplayedPeriod = null;
			var displayedPeriod = _this.props.displayedPeriod;

			if (type === 'days') {
				newDisplayedPeriod = Moment(displayedPeriod.format('YYYY') + value, "YYYY MMM");
			} else if (type === 'months') {
				newDisplayedPeriod = Moment(displayedPeriod.format('MM') + value, "MM YYYY");
			}

			var goToViewType = _this.props.goToViewType;

			goToViewType(type, newDisplayedPeriod);
		}, _temp), _possibleConstructorReturn$7$1(_this, _ret);
	}

	_createClass$7$1(Body, [{
		key: 'renderBody',
		value: function renderBody(displayedPeriod) {
			var viewType = this.props.viewType;

			switch (viewType) {
				case 'months':
					return this.renderListMonths();
				case "years":
					return this.renderListYears(displayedPeriod);
				default:
					return this.renderWeeks(displayedPeriod);
			}
		}
	}, {
		key: 'renderWeeks',
		value: function renderWeeks(displayMonth) {
			var _this2 = this;

			var _daysOfMonth = daysOfMonth$1(displayMonth);
			var _weekEnum = weekEnum$1(_daysOfMonth);
			return _weekEnum.map(function (week, key) {
				return React.createElement('tr', { key: key }, _this2.renderDay(_daysOfMonth, week));
			});
		}
	}, {
		key: 'renderListMonths',
		value: function renderListMonths() {
			var months = Moment.monthsShort();
			return React.createElement(Rows$1, { list: months, rowLength: 4, onClick: this.handleOnClick.bind(this, 'days') });
		}
	}, {
		key: 'renderListYears',
		value: function renderListYears(displayMonth) {
			var years = yearsOfMonth$1(displayMonth);
			return React.createElement(Rows$1, { list: years, rowLength: 4, onClick: this.handleOnClick.bind(this, 'months') });
		}
	}, {
		key: 'renderDay',
		value: function renderDay(_daysOfMonth, week) {
			var _this3 = this;

			var days = [0, 1, 2, 3, 4, 5, 6];
			var _props = this.props,
			    activeDate = _props.activeDate,
			    displayedPeriod = _props.displayedPeriod,
			    selectedDates = _props.selectedDates,
			    minDate = _props.minDate,
			    maxDate = _props.maxDate,
			    format = _props.format,
			    noWeekends = _props.noWeekends,
			    selectDay = _props.selectDay;

			return days.map(function (day, key) {
				var date = _daysOfMonth[week * 7 + day];
				var disabled = void 0;
				var selected = false;

				if (minDate && maxDate) {
					disabled = date.isBefore(minDate, 'day') || date.isAfter(maxDate, 'day');
				} else if (minDate) {
					disabled = date.isBefore(minDate, 'day');
				} else if (maxDate) {
					disabled = date.isAfter(maxDate, 'day');
				}

				if (noWeekends) {
					disabled = date.day() === 6 || date.day() === 0;
				}

				var dayNextMonth = isDateFromNextMonth$1(date, displayedPeriod);
				var dayPrevMonth = isDateFromPrevMonth$1(date, displayedPeriod);

				selectedDates.forEach(function (selectedDate) {
					if (date.isSame(Moment(selectedDate, format), 'day')) {
						selected = true;
						dayPrevMonth = false;
						dayNextMonth = false;
					}
				});

				return React.createElement(Day$1, {
					key: key,
					day: date,
					selectDay: selectDay.bind(_this3, date),
					disabled: disabled,
					selected: selected,
					dayPrevMonth: dayPrevMonth,
					dayNextMonth: dayNextMonth,
					activeDate: activeDate });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var displayedPeriod = this.props.displayedPeriod;

			return this.renderBody(displayedPeriod);
		}
	}]);

	return Body;
}(Component);

Body$1.defaultProps = {
	selectedDates: []
};

var _createClass$8$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$8$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$8$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$8$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Head$1 = function (_Component) {
	_inherits$8$1(Head, _Component);

	function Head() {
		_classCallCheck$8$1(this, Head);

		return _possibleConstructorReturn$8$1(this, (Head.__proto__ || Object.getPrototypeOf(Head)).apply(this, arguments));
	}

	_createClass$8$1(Head, [{
		key: 'renderHeader',
		value: function renderHeader() {
			var viewType = this.props.viewType;

			switch (viewType) {
				case 'months':
					return null;
				case 'years':
					return null;
				default:
					return this.renderNameOfDays();
			}
		}
	}, {
		key: 'renderNameOfDays',
		value: function renderNameOfDays() {
			var nameOfDays = Moment.weekdaysShort();
			return React.createElement('tr', { className: 'm-datepicker__days' }, nameOfDays.map(function (day, i) {
				return React.createElement('th', { key: i }, day);
			}));
		}
	}, {
		key: 'render',
		value: function render() {
			return this.renderHeader();
		}
	}]);

	return Head;
}(Component);

var _createClass$9$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$9$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$9$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$9$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Calendar$2 = function (_Component) {
	_inherits$9$1(Calendar, _Component);

	function Calendar() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$9$1(this, Calendar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$9$1(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			displayedPeriod: _this.props.activeDate ? Moment(_this.props.activeDate, _this.props.format) : Moment(),
			viewType: "days",
			views: ["days", "months", "years"]
		}, _temp), _possibleConstructorReturn$9$1(_this, _ret);
	}

	_createClass$9$1(Calendar, [{
		key: 'changeViewType',
		value: function changeViewType() {
			var _state = this.state,
			    viewType = _state.viewType,
			    views = _state.views;

			var switchTo = nextItemInArray$1(viewType, views);
			this.goToViewType(switchTo);
		}
	}, {
		key: 'goToViewType',
		value: function goToViewType(switchTo) {
			var displayedPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

			this.setState({
				viewType: switchTo,
				displayedPeriod: displayedPeriod || this.state.displayedPeriod
			});
		}
	}, {
		key: 'moveDisplayedPeriod',
		value: function moveDisplayedPeriod(delta) {
			var _state2 = this.state,
			    viewType = _state2.viewType,
			    displayedPeriod = _state2.displayedPeriod;

			var period = viewType === 'days' ? 'months' : 'years';

			this.setState({
				displayedPeriod: displayedPeriod.clone().add(delta, period)
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    selectDay = _props.selectDay,
			    activeDate = _props.activeDate,
			    selectedDates = _props.selectedDates,
			    minDate = _props.minDate,
			    maxDate = _props.maxDate,
			    format = _props.format,
			    noWeekends = _props.noWeekends;
			var _state3 = this.state,
			    viewType = _state3.viewType,
			    displayedPeriod = _state3.displayedPeriod;

			return React.createElement(React.Fragment, null, React.createElement('div', { className: 'm-datepicker__nav' }, React.createElement(Nav$1, {
				viewType: viewType,
				displayedPeriod: displayedPeriod,
				onClickPrevious: this.moveDisplayedPeriod.bind(this, -1),
				onClickViewType: this.changeViewType.bind(this),
				onClickNext: this.moveDisplayedPeriod.bind(this, 1)
			})), React.createElement('table', { cellPadding: '0', cellSpacing: '0' }, React.createElement('thead', null, React.createElement(Head$1, {
				displayedPeriod: displayedPeriod,
				viewType: viewType
			})), React.createElement('tbody', { className: 'm-datepicker__calendar' }, React.createElement(Body$1, {
				viewType: viewType,
				displayedPeriod: displayedPeriod,
				selectDay: selectDay.bind(this),
				selectedDates: selectedDates,
				minDate: minDate,
				maxDate: maxDate,
				format: format,
				noWeekends: noWeekends,
				activeDate: activeDate,
				goToViewType: this.goToViewType.bind(this)
			}))));
		}
	}]);

	return Calendar;
}(Component);

var _createClass$a$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$a$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$a$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$a$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DatePicker$1 = function (_Component) {
	_inherits$a$1(DatePicker, _Component);

	function DatePicker() {
		_classCallCheck$a$1(this, DatePicker);

		return _possibleConstructorReturn$a$1(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
	}

	_createClass$a$1(DatePicker, [{
		key: 'renderCalendar',
		value: function renderCalendar() {
			var _props = this.props,
			    activeDate = _props.activeDate,
			    minDate = _props.minDate,
			    maxDate = _props.maxDate,
			    format = _props.format,
			    selectedDates = _props.selectedDates,
			    noWeekends = _props.noWeekends,
			    clickOnDate = _props.clickOnDate;

			return React.createElement(Calendar$2, {
				activeDate: activeDate,
				minDate: minDate,
				maxDate: maxDate,
				format: format,
				selectedDates: selectedDates,
				noWeekends: noWeekends,
				selectDay: clickOnDate.bind(this) });
		}
	}, {
		key: 'render',
		value: function render() {
			return this.renderCalendar();
		}
	}]);

	return DatePicker;
}(Component);

var _createClass$b$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$b$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$b$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$b$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Calendar$1$1 = function (_Component) {
	_inherits$b$1(Calendar, _Component);

	function Calendar(props) {
		_classCallCheck$b$1(this, Calendar);

		var _this = _possibleConstructorReturn$b$1(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

		var _this$props = _this.props,
		    activeDate = _this$props.activeDate,
		    format = _this$props.format;

		Moment.updateLocale('nl', {
			months: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
			weekdaysShort: ["Ma", "Di", "Woe", "Do", "Vr", "Za", "Zo"]
		});

		_this.state = {
			activeDate: activeDate ? Moment(activeDate, format) : ''
		};
		return _this;
	}

	_createClass$b$1(Calendar, [{
		key: 'changeDate',
		value: function changeDate(day) {
			var _props = this.props,
			    onChange = _props.onChange,
			    format = _props.format;

			if (onChange) onChange(Moment(day).format(format));

			this.setState({
				activeDate: day
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    format = _props2.format,
			    selectedDates = _props2.selectedDates,
			    minDate = _props2.minDate,
			    maxDate = _props2.maxDate,
			    noWeekends = _props2.noWeekends;
			var activeDate = this.state.activeDate;

			return React.createElement('div', { className: 'm-datepicker is-open' }, React.createElement(DatePicker$1, {
				format: format,
				activeDate: activeDate,
				selectedDates: selectedDates,
				minDate: Moment(minDate, format),
				maxDate: Moment(maxDate, format),
				noWeekends: noWeekends,
				clickOnDate: this.changeDate.bind(this)
			}));
		}
	}], [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(nextProps, prevState) {
			if (nextProps.activeDate) {
				return {
					activeDate: Moment(nextProps.activeDate, nextProps.format)
				};
			}
			return null;
		}
	}]);

	return Calendar;
}(Component);

Calendar$1$1.defaultProps = {
	format: 'DD/MM/YYYY',
	noWeekends: false
};

var _createClass$c$1 = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$c$1(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$c$1(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$7(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$c$1(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$7(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Datepicker = function (_Component) {
	_inherits$c$1(Datepicker, _Component);

	function Datepicker(props) {
		_classCallCheck$c$1(this, Datepicker);

		var _this = _possibleConstructorReturn$c$1(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, props));

		_this.handleClickOutside = function (e) {
			if (_this.datepicker && _this.datepicker.contains(e.target)) {
				return;
			}

			_this.setState({ open: false });
		};

		var _this$props = _this.props,
		    activeDate = _this$props.activeDate,
		    open = _this$props.open,
		    format = _this$props.format;

		_this.state = {
			activeDate: activeDate ? Moment(activeDate, format) : '',
			open: open || false
		};
		return _this;
	}

	_createClass$c$1(Datepicker, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof window !== 'undefined') {
				document.addEventListener('mousedown', this.handleClickOutside.bind(this));
				document.addEventListener('touchstart', this.handleClickOutside.bind(this));
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (typeof window !== 'undefined') {
				document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
				document.removeEventListener('touchstart', this.handleClickOutside.bind(this));
			}
		}
	}, {
		key: 'changeDate',
		value: function changeDate(day) {
			var _props = this.props,
			    onChange = _props.onChange,
			    format = _props.format,
			    autoClose = _props.autoClose;

			if (onChange) onChange(day);

			this.setState({
				activeDate: Moment(day, format),
				open: !autoClose || false
			});
		}
	}, {
		key: 'toggleCalendar',
		value: function toggleCalendar() {
			this.setState({
				open: !this.state.open
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props2 = this.props,
			    label = _props2.label,
			    id = _props2.id,
			    required = _props2.required,
			    name = _props2.name,
			    format = _props2.format,
			    selectedDates = _props2.selectedDates,
			    minDate = _props2.minDate,
			    maxDate = _props2.maxDate,
			    noWeekends = _props2.noWeekends;
			var _state = this.state,
			    activeDate = _state.activeDate,
			    open = _state.open;

			var datepickerWrapperClass = classNames('a-input', 'has-icon-right', {
				'is-required': !!required
			});

			var datepickerClass = classNames('m-datepicker', 'm-datepicker--fixed', {
				'is-open': open
			});

			return React.createElement('div', { className: datepickerWrapperClass, ref: function ref(node) {
					return _this2.datepicker = node;
				} }, label && React.createElement(InputLabel$1, { htmlFor: id }, label), React.createElement('div', { className: 'a-input__wrapper' }, React.createElement(TextField$1, {
				name: name,
				id: id,
				required: required,
				value: activeDate ? Moment(activeDate).format(format) : '',
				onClick: this.toggleCalendar.bind(this),
				onChange: this.changeDate.bind(this),
				readOnly: true }), React.createElement('span', { onClick: this.toggleCalendar.bind(this), className: 'fa fa-calendar is-clickable' }), open && React.createElement('div', { className: datepickerClass, 'aria-hidden': 'false' }, React.createElement('div', { className: 'm-datepicker is-open' }, React.createElement(Calendar$1$1, {
				format: format,
				activeDate: activeDate,
				selectedDates: selectedDates,
				minDate: minDate,
				maxDate: maxDate,
				noWeekends: noWeekends,
				onChange: this.changeDate.bind(this)
			})))));
		}
	}]);

	return Datepicker;
}(Component);

Datepicker.defaultProps = {
	required: false,
	format: 'DD/MM/YYYY',
	autoClose: true,
	noWeekends: false
};

var Header = function Header(props) {
  var children = props.children,
      style = props.style,
      className = props.className;

  var headerClass = classNames('o-header', className);
  return React.createElement('header', { className: headerClass, style: style }, React.createElement('a', { href: '/', className: 'o-header__logo' }, React.createElement('img', { src: 'https://cdn.antwerpen.be/core_branding_scss/3.1.0/assets/images/a-logo.svg', alt: 'Official logo Antwerpen' })), children);
};

var styles = {
  overflow: 'auto'
};

var Hero = function Hero(props) {
  var children = props.children;

  return React.createElement('div', { className: 'u-wrapper u-bg-light', style: styles }, React.createElement('div', { className: 'u-container' }, React.createElement('div', { className: 'u-text-center u-margin-lg' }, children)));
};

var Icon$7 = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var typeClasses$7 = {
  primary: 'a-label--primary',
  secondary: 'a-label--secondary',
  success: 'a-label--success',
  warning: 'a-label--warning',
  danger: 'a-label--danger'
};

var Label = function Label(props) {
  var type = props.type,
      className = props.className,
      _props$style = props.style,
      style = _props$style === undefined ? {} : _props$style,
      children = props.children;

  var labelClass = classNames('a-label', className, _defineProperty$9({}, '' + typeClasses$7[type], !!type));

  return React.createElement('span', { className: labelClass, style: style }, children);
};

var _typeof$8 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass$d = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$d(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$8(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$8(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Steps = function (_Component) {
  _inherits$d(Steps, _Component);

  function Steps() {
    _classCallCheck$d(this, Steps);

    return _possibleConstructorReturn$d(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).apply(this, arguments));
  }

  _createClass$d(Steps, [{
    key: "renderStep",
    value: function renderStep(child, i) {
      return cloneElement(child, {
        completed: i < this.props.current,
        active: i === this.props.current
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;

      return React.createElement("div", { className: className }, React.createElement("ol", { className: "m-step-indicator" }, this.props.children.map(function (child, i) {
        return _this2.renderStep(child, i);
      })));
    }
  }]);

  return Steps;
}(Component);

var _createClass$1$5 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$1$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1$5(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$8(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$8(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Step = function (_Component) {
  _inherits$1$5(Step, _Component);

  function Step() {
    _classCallCheck$1$5(this, Step);

    return _possibleConstructorReturn$1$5(this, (Step.__proto__ || Object.getPrototypeOf(Step)).apply(this, arguments));
  }

  _createClass$1$5(Step, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          active = _props.active,
          completed = _props.completed;

      var stepClass = classNames({
        'is-active': !!active,
        'is-completed': !!completed
      });

      return React.createElement('li', { className: stepClass }, React.createElement('span', { className: 'm-step-indicator__label' }, title));
    }
  }]);

  return Step;
}(Component);

var _typeof$9 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var InputLabel$2 = function InputLabel(props) {
  var style = props.style,
      htmlFor = props.htmlFor,
      children = props.children,
      inline = props.inline;

  var labelClass = classNames('a-input__label', {
    'a-input__label--inline': !!inline
  });
  return React.createElement('label', { className: labelClass, htmlFor: htmlFor, style: style }, children);
};

var Bar = function Bar(_ref) {
  var start = _ref.start,
      end = _ref.end,
      getPositionFromValue = _ref.getPositionFromValue,
      range = _ref.range;
  return React.createElement('div', {
    className: 'm-range-slider__bar',
    style: {
      left: range && getPositionFromValue(start) + 'px',
      width: range ? getPositionFromValue(end - start) + 'px' : getPositionFromValue(start) + 'px'
    } });
};

var _createClass$e = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$e(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$9(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$9(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Handle = function (_Component) {
  _inherits$e(Handle, _Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$e(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$e(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      limit: 480,
      grab: 5
    }, _this.handleNoop = function (e) {
      e.stopPropagation();
      e.preventDefault();
    }, _this.handleStart = function () {
      document.addEventListener('mousemove', _this.handleDrag);
      document.addEventListener('mouseup', _this.handleEnd);
    }, _this.handleDrag = function (e) {
      _this.handleNoop(e);
      var onChange = _this.props.onChange;

      if (!onChange) return;

      var value = _this.position(e);
      onChange && onChange(value);
    }, _this.handleEnd = function (e) {
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleEnd);

      var onDragEnd = _this.props.onDragEnd;

      if (!onDragEnd) return;
      var value = _this.position(e);
      onDragEnd && onDragEnd(value);
    }, _this.position = function (e) {
      var grab = _this.state.grab;
      var direction = _this.props.direction;

      var clientCoordinateStyle = 'clientX';
      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];

      var pos = coordinate - direction - grab;
      return _this.getValueFromPosition(pos);
    }, _this.getValueFromPosition = function (pos) {
      var limit = _this.state.limit;
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step;

      var percentage = clamp(pos, 0, limit) / (limit || 1);
      var baseVal = step * Math.round(percentage * (max - min) / step);

      var value = baseVal + min;

      if (value >= max) value = max;
      if (value <= min) value = min;

      return value;
    }, _temp), _possibleConstructorReturn$e(_this, _ret);
  }

  _createClass$e(Handle, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var sliderPos = nextProps.sliderPos;

      var handlePos = 30; // Fills the bar up correctly on the right side

      this.setState({
        limit: sliderPos - handlePos
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          handleNoop = _props.handleNoop,
          getPositionFromValue = _props.getPositionFromValue,
          unit = _props.unit,
          fixed = _props.fixed,
          tooltips = _props.tooltips,
          onDragEnd = _props.onDragEnd;

      return React.createElement('div', {
        className: 'm-range-slider__handle',
        onMouseDown: this.handleStart,
        onTouchEnd: handleNoop,
        onTouchMove: this.handleDrag,
        onDragExit: onDragEnd,
        style: {
          left: getPositionFromValue(value) + 'px'
        }
      }, tooltips ? React.createElement('div', { className: 'm-range-slider__tooltip a-tooltip a-tooltip--primary a-tooltip--top' }, React.createElement('p', null, value.toFixed(fixed).replace(/[.]/, ","), '\xA0', unit)) : React.createElement('span', { className: 'm-range-slider__value' }, value.toFixed(fixed).replace(/[.]/, ","), '\xA0', unit));
    }
  }]);

  return Handle;
}(Component);

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

var _createClass$1$6 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$1$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1$6(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$9(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$9(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Slider = function (_Component) {
  _inherits$1$6(Slider, _Component);

  function Slider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1$6(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1$6(this, (_ref = Slider.__proto__ || Object.getPrototypeOf(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      limit: 0,
      start: _this.props.start,
      end: _this.props.end
    }, _this.onDragEnd = function () {
      var _this$state = _this.state,
          start = _this$state.start,
          end = _this$state.end;
      var onDragEnd = _this.props.onDragEnd;

      if (!onDragEnd) return;
      onDragEnd && onDragEnd(start, end);
    }, _this.updateStart = function (start) {
      var end = _this.state.end;
      var minRange = _this.props.minRange;

      if (end - start < minRange) {
        end = start + minRange;
      }

      _this.onChange(start, end);
    }, _this.updateEnd = function (end) {
      var start = _this.state.start;
      var minRange = _this.props.minRange;

      if (end - start < minRange) {
        start = end - minRange;
      }

      _this.onChange(start, end);
    }, _this.handleUpdate = function () {
      var sliderPos = _this.slider['offsetWidth'];
      var handlePos = 30; // Fills the bar up correctly on the right side

      var node = _this.slider;
      var direction = node.getBoundingClientRect()['left'];

      _this.setState({
        limit: sliderPos - handlePos,
        sliderPos: sliderPos,
        direction: direction
      });
    }, _this.handleNoop = function (e) {
      e.stopPropagation();
      e.preventDefault();
    }, _this.onChange = function (start, end) {
      var onChange = _this.props.onChange;

      _this.setState({
        start: start, end: end
      });

      if (!onChange) return;
      onChange(start, end);
    }, _this.getPositionFromValue = function (value) {
      var limit = _this.state.limit;
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;

      var diffMaxMin = max - min;
      var diffValMin = value - min;
      var percentage = diffValMin / diffMaxMin;

      return Math.round(percentage * limit);
    }, _temp), _possibleConstructorReturn$1$6(_this, _ret);
  }

  _createClass$1$6(Slider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleUpdate);
      this.handleUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          id = _props.id,
          label = _props.label,
          min = _props.min,
          max = _props.max,
          step = _props.step,
          unit = _props.unit,
          minRange = _props.minRange,
          tooltips = _props.tooltips,
          range = _props.range,
          fixed = _props.fixed;
      var _state = this.state,
          sliderPos = _state.sliderPos,
          direction = _state.direction,
          start = _state.start,
          end = _state.end;

      return React.createElement('div', { id: id }, label && React.createElement(InputLabel$2, { htmlFor: id }, label), React.createElement('div', { className: 'm-range-slider', ref: function ref(s) {
          _this2.slider = s;
        } }, React.createElement('div', { className: 'm-range-slider__inner' }, React.createElement(Bar, {
        start: start,
        end: end,
        getPositionFromValue: this.getPositionFromValue,
        range: range
      }), React.createElement(Handle, {
        value: start,
        onChange: this.updateStart,
        min: min,
        max: max - minRange,
        step: step,
        unit: unit,
        fixed: fixed,
        handleNoop: this.handleNoop,
        sliderPos: sliderPos,
        direction: direction,
        getPositionFromValue: this.getPositionFromValue,
        tooltips: tooltips,
        onDragEnd: this.onDragEnd
      }), range && React.createElement(Handle, {
        value: end,
        onChange: this.updateEnd,
        min: min + minRange,
        max: max,
        step: step,
        unit: unit,
        fixed: fixed,
        handleNoop: this.handleNoop,
        sliderPos: sliderPos,
        direction: direction,
        getPositionFromValue: this.getPositionFromValue,
        tooltips: tooltips,
        onDragEnd: this.onDragEnd
      }))));
    }
  }]);

  return Slider;
}(Component);

Slider.defaultProps = {
  start: 0,
  end: 100,
  min: 0,
  max: 100,
  step: 1,
  unit: '%',
  minRange: 0,
  fixed: 0,
  tooltips: false,
  range: false
};

function _defineProperty$a(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var spinnerSizes = {
  small: 'sm',
  large: 'lg'
};

var Spinner = function Spinner(props) {
  var size = props.size,
      style = props.style,
      className = props.className;

  var spinnerClass = classNames('a-spinner', className, _defineProperty$a({}, 'a-spinner--' + spinnerSizes[size], !!size));

  return React.createElement('div', { className: spinnerClass, style: style });
};

var _typeof$a = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var Link = function Link(_ref) {
  var component = _ref.component,
      children = _ref.children,
      props = _objectWithoutProperties$3(_ref, ['component', 'children']);

  return createElement(component, props, children);
};

Link.defaultProps = { component: 'a' };

var _createClass$f = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$f(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$a(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$f(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$a(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Breadcrumbs = function (_React$Component) {
  _inherits$f(Breadcrumbs, _React$Component);

  function Breadcrumbs() {
    _classCallCheck$f(this, Breadcrumbs);

    return _possibleConstructorReturn$f(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).apply(this, arguments));
  }

  _createClass$f(Breadcrumbs, [{
    key: 'renderItems',
    value: function renderItems() {
      var _props = this.props,
          items = _props.items,
          linkProps = _props.linkProps;

      return items.map(function (item, index) {
        return React.createElement('li', { key: item.name }, index >= items.length - 1 || !item.target ? item.name : React.createElement(Link, linkProps({ href: item.target }), item.name));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var items = this.props.items;

      return items && items.length > 0 && React.createElement('ul', { className: 'm-breadcrumbs' }, this.renderItems());
    }
  }]);

  return Breadcrumbs;
}(React.Component);

Breadcrumbs.defaultProps = {
  linkProps: function linkProps(src) {
    return src;
  }
};

var _typeof$b = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var InputLabel$3 = function InputLabel(props) {
	var style = props.style,
	    htmlFor = props.htmlFor,
	    children = props.children,
	    inline = props.inline;

	var labelClass = classNames('a-input__label', {
		'a-input__label--inline': !!inline
	});
	return React.createElement('label', { className: labelClass, htmlFor: htmlFor, style: style }, children);
};

var _createClass$g = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck$g(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn$g(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$b(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$g(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$b(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Switch = function (_Component) {
	_inherits$g(Switch, _Component);

	function Switch() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck$g(this, Switch);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn$g(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			checked: _this.props.checked || false
		}, _this.onClick = function (e) {
			_this.setState({ checked: !_this.state.checked });

			if (_this.props.onClick) {
				_this.props.onClick(e);
			}
		}, _temp), _possibleConstructorReturn$g(_this, _ret);
	}

	_createClass$g(Switch, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    label = _props.label,
			    name = _props.name,
			    labelTrue = _props.labelTrue,
			    labelFalse = _props.labelFalse,
			    required = _props.required,
			    disabled = _props.disabled;

			var containerClass = classNames('a-input', { 'is-required': !!required });

			var switchWrapperClass = classNames('a-switch', { 'disabled': disabled });

			return React.createElement('div', { className: containerClass }, label && React.createElement(InputLabel$3, { htmlFor: id }, label), React.createElement('div', { className: switchWrapperClass }, React.createElement('label', { className: 'a-switch__label' }, labelFalse ? labelFalse : 'Nee'), React.createElement('div', { className: 'a-switch__toggle' }, React.createElement('input', {
				type: 'checkbox',
				name: name,
				id: id,
				defaultChecked: this.state.checked,
				disabled: disabled,
				onChange: this.onClick
			}), React.createElement('label', { htmlFor: id })), React.createElement('label', { className: 'a-switch__label' }, labelTrue ? labelTrue : 'Ja')));
		}
	}], [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(nextProps, prevState) {
			if (nextProps.checked !== prevState.checked) {
				return {
					checked: nextProps.checked
				};
			}

			return null;
		}
	}]);

	return Switch;
}(Component);

var _typeof$c = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var Link$1 = function Link(_ref) {
  var component = _ref.component,
      children = _ref.children,
      props = _objectWithoutProperties$4(_ref, ['component', 'children']);

  return createElement(component, props, children);
};

Link$1.defaultProps = { component: 'a' };

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass$h = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$h(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$c(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$h(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$c(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Tabs = function (_React$Component) {
  _inherits$h(Tabs, _React$Component);

  function Tabs() {
    _classCallCheck$h(this, Tabs);

    return _possibleConstructorReturn$h(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
  }

  _createClass$h(Tabs, [{
    key: 'renderItems',
    value: function renderItems() {
      var _props = this.props,
          items = _props.items,
          linkProps = _props.linkProps;

      return items.map(function (item) {
        return React.createElement('li', { key: item.name }, React.createElement(Link$1, _extends$3({
          className: classNames({ 'is-active': item.active, 'is-disabled': item.disabled })
        }, linkProps({ href: item.target })), item.name));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          align = _props2.align,
          items = _props2.items;

      var tabClasses = classNames('m-nav-tabs', {
        'm-nav-tabs--left': align === 'left',
        'm-nav-tabs--right': align === 'right'
      });

      return items && items.length > 0 && React.createElement('ul', { className: tabClasses }, this.renderItems());
    }
  }]);

  return Tabs;
}(React.Component);

Tabs.defaultProps = {
  align: 'left',
  linkProps: function linkProps(src) {
    return src;
  }
};

var _typeof$d = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var TagList = function TagList(_ref) {
  var children = _ref.children;

  return React.createElement("ul", { className: "o-tag-list" }, children);
};

var Icon$8 = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

var _createClass$i = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$b(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$i(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$d(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$i(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$d(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses$6 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$8 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent'
};

var Button$5 = function (_Component) {
  _inherits$i(Button, _Component);

  function Button() {
    _classCallCheck$i(this, Button);

    return _possibleConstructorReturn$i(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass$i(Button, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          negative = _props.negative,
          outline = _props.outline,
          transparent = _props.transparent,
          className = _props.className,
          children = _props.children,
          icon = _props.icon,
          iconLeft = _props.iconLeft,
          iconRight = _props.iconRight,
          onClick = _props.onClick,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          type = _props.type,
          size = _props.size,
          _props$block = _props.block,
          block = _props$block === undefined ? false : _props$block,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          htmlType = _props.htmlType;

      var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty$b(_classNames, '' + typeClasses$8[type], !!type), _defineProperty$b(_classNames, '' + sizeClasses$6[size], !!size), _defineProperty$b(_classNames, 'has-icon', !!icon), _defineProperty$b(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$b(_classNames, 'has-icon-right', !!iconRight), _defineProperty$b(_classNames, 'a-button-negative', !!negative), _defineProperty$b(_classNames, 'a-button-outline', !!outline), _defineProperty$b(_classNames, 'a-button--block', block), _classNames));

      return React.createElement('button', {
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType }, icon ? React.createElement(Icon$8, { name: icon }) : null, iconLeft ? React.createElement(Icon$8, { name: iconLeft }) : null, iconRight ? React.createElement(Icon$8, { name: iconRight }) : null, children);
    }
  }]);

  return Button;
}(Component);

var _createClass$1$7 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$1$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1$7(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$d(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$d(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TagListItem = function (_Component) {
  _inherits$1$7(TagListItem, _Component);

  function TagListItem() {
    _classCallCheck$1$7(this, TagListItem);

    return _possibleConstructorReturn$1$7(this, (TagListItem.__proto__ || Object.getPrototypeOf(TagListItem)).apply(this, arguments));
  }

  _createClass$1$7(TagListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          _props$closable = _props.closable,
          closable = _props$closable === undefined ? false : _props$closable,
          _props$icon = _props.icon,
          icon = _props$icon === undefined ? '' : _props$icon,
          _props$buttonClass = _props.buttonClass,
          onClick = _props.onClick;

      return React.createElement('li', { className: 'm-tag' }, icon && React.createElement(Button$5, { size: 'small', icon: icon }), React.createElement('span', { className: 'm-tag__label' }, value), closable && React.createElement(Button$5, { transparent: true, size: 'small', type: 'danger', icon: 'close', onClick: onClick }));
    }
  }]);

  return TagListItem;
}(Component);

var _typeof$e = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass$j = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$c(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$j(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$e(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$j(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$e(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var sizeClasses$7 = {
  tiny: 'a-toggle--tiny',
  small: 'a-toggle--small',
  large: 'a-toggle--large'
};

var sizeBtnClasses = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};

var Toggle = function (_Component) {
  _inherits$j(Toggle, _Component);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$j(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$j(this, (_ref = Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checked: _this.props.checked || false
    }, _this.handleClick = function (e) {
      _this.setState({ checked: !_this.state.checked });
      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    }, _temp), _possibleConstructorReturn$j(_this, _ret);
  }

  _createClass$j(Toggle, [{
    key: 'render',
    value: function render() {
      var _classNames2, _classNames3;

      var _props = this.props,
          id = _props.id,
          name = _props.name,
          size = _props.size,
          checkedLabel = _props.checkedLabel,
          checkedIcon = _props.checkedIcon,
          checkedButtonClass = _props.checkedButtonClass,
          uncheckedLabel = _props.uncheckedLabel,
          uncheckedIcon = _props.uncheckedIcon,
          uncheckedButtonClass = _props.uncheckedButtonClass;

      var toggleClass = classNames('a-toggle has-icon', _defineProperty$c({}, '' + sizeClasses$7[size], !!size));

      var checkedClasses = classNames('a-toggle__on a-button', checkedLabel === '' ? 'has-icon' : 'has-icon-left', (_classNames2 = {}, _defineProperty$c(_classNames2, '' + checkedButtonClass, checkedButtonClass), _defineProperty$c(_classNames2, '' + sizeBtnClasses[size], !!size), _classNames2));

      var uncheckedClasses = classNames('a-toggle__off a-button', uncheckedLabel === '' ? 'has-icon' : 'has-icon-left', (_classNames3 = {}, _defineProperty$c(_classNames3, '' + uncheckedButtonClass, uncheckedButtonClass), _defineProperty$c(_classNames3, '' + sizeBtnClasses[size], !!size), _classNames3));

      return React.createElement('div', { className: toggleClass }, React.createElement('input', {
        className: 'a-toggle__checkbox',
        id: id,
        name: name,
        checked: this.state.checked,
        type: 'checkbox',
        onClick: this.handleClick
      }), React.createElement('div', { className: 'a-toggle__labels' }, React.createElement('label', { htmlFor: id, className: checkedClasses }, React.createElement('i', { className: "fa " + checkedIcon }), checkedLabel), React.createElement('label', { htmlFor: id, className: uncheckedClasses }, React.createElement('i', { className: "fa " + uncheckedIcon }), uncheckedLabel)));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.checked !== prevState.checked) {
        return {
          checked: nextProps.checked
        };
      }

      return null;
    }
  }]);

  return Toggle;
}(Component);

Toggle.defaultProps = {
  id: 'toggle-normal',
  checkedLabel: '',
  checkedIcon: 'fa-bars',
  checkedButtonClass: '',
  uncheckedLabel: '',
  uncheckedIcon: 'fa-close',
  uncheckedButtonClass: 'a-button--danger'
};

var _typeof$f = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Icon$9 = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

function _defineProperty$d(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var sizeClasses$8 = {
  small: 'a-avatar--small',
  medium: 'a-avatar--medium',
  large: 'a-avatar--large'
};

var IconWrapper$1 = function IconWrapper(_ref) {
  var icon = _ref.icon;
  return React.createElement('span', { className: 'a-avatar__icon' }, React.createElement(Icon$9, { name: icon }));
};
var LetterWrapper$1 = function LetterWrapper(_ref2) {
  var letter = _ref2.letter;
  return React.createElement('span', { className: 'a-avatar__letter' }, letter);
};

var Avatar$1 = function Avatar(props) {
  var size = props.size,
      icon = props.icon,
      children = props.children,
      style = props.style,
      letter = props.letter,
      image = props.image,
      _props$alt = props.alt,
      alt = _props$alt === undefined ? '' : _props$alt,
      className = props.className;

  var avatarClass = classNames('a-avatar', _defineProperty$d({}, '' + sizeClasses$8[size], !!size), className);

  return React.createElement('div', { className: avatarClass, style: style }, icon && React.createElement(IconWrapper$1, { icon: icon }), letter && React.createElement(LetterWrapper$1, { letter: letter }), image && React.createElement('img', { src: image, alt: alt }), children);
};

var _createClass$k = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$1$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$k(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$f(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$k(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$f(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses$1$1 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$9 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent'
};

var Button$6 = function (_Component) {
  _inherits$k(Button, _Component);

  function Button() {
    _classCallCheck$k(this, Button);

    return _possibleConstructorReturn$k(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass$k(Button, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          negative = _props.negative,
          outline = _props.outline,
          transparent = _props.transparent,
          className = _props.className,
          children = _props.children,
          icon = _props.icon,
          iconLeft = _props.iconLeft,
          iconRight = _props.iconRight,
          onClick = _props.onClick,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          type = _props.type,
          size = _props.size,
          _props$block = _props.block,
          block = _props$block === undefined ? false : _props$block,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          htmlType = _props.htmlType;

      var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty$1$3(_classNames, '' + typeClasses$9[type], !!type), _defineProperty$1$3(_classNames, '' + sizeClasses$1$1[size], !!size), _defineProperty$1$3(_classNames, 'has-icon', !!icon), _defineProperty$1$3(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$1$3(_classNames, 'has-icon-right', !!iconRight), _defineProperty$1$3(_classNames, 'a-button-negative', !!negative), _defineProperty$1$3(_classNames, 'a-button-outline', !!outline), _defineProperty$1$3(_classNames, 'a-button--block', block), _classNames));

      return React.createElement('button', {
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType }, icon ? React.createElement(Icon$9, { name: icon }) : null, iconLeft ? React.createElement(Icon$9, { name: iconLeft }) : null, iconRight ? React.createElement(Icon$9, { name: iconRight }) : null, children);
    }
  }]);

  return Button;
}(Component);

var FlyoutContent$3 = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children;

  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });

  return React.createElement('div', { className: classes }, children);
};

var _createClass$1$8 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$2$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$1$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1$8(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$f(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$f(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var flyoutSizes$3 = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var Flyout$2 = function (_Component) {
  _inherits$1$8(Flyout, _Component);

  function Flyout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1$8(this, Flyout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1$8(this, (_ref = Flyout.__proto__ || Object.getPrototypeOf(Flyout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: _this.props.open
    }, _this.flyoutRef = React.createRef(), _this.toggleIsOpen = function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }
      _this.setState({ isOpen: !_this.state.isOpen });
      onStateChange(_this.state.isOpen);
    }, _this.closeFlyout = function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }
      _this.setState({ isOpen: false });
      onStateChange(false);
    }, _this.handleOutsideClick = function (e) {
      var area = ReactDOM.findDOMNode(_this.flyoutRef.current);
      if (area && !area.contains(e.target)) {
        _this.closeFlyout();
      }
    }, _this.getClassNames = function () {
      return classNames(_this.props.className, 'm-flyout', 'm-flyout--' + _this.props.direction, _defineProperty$2$3({
        'is-open': _this.state.isOpen,
        'm-flyout--scrollable': _this.props.scrollable
      }, 'm-flyout--' + flyoutSizes$3[_this.props.size], !!flyoutSizes$3[_this.props.size]));
    }, _temp), _possibleConstructorReturn$1$8(_this, _ret);
  }

  _createClass$1$8(Flyout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isOpen = this.state.isOpen;

      if (isOpen) {
        document.addEventListener('click', this.handleOutsideClick, false);
      }

      this.props.triggerClose(this.closeFlyout);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({ isOpen: !prevProps.open });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          hasPadding = _props.hasPadding,
          children = _props.children;

      var flyoutClass = this.getClassNames();
      return trigger && React.createElement('div', { className: flyoutClass, ref: this.flyoutRef }, React.createElement('div', { onClick: this.toggleIsOpen }, this.props.trigger), React.createElement(FlyoutContent$3, { hasPadding: hasPadding }, children));
    }
  }]);

  return Flyout;
}(Component);

Flyout$2.defaultProps = {
  direction: 'left',
  size: 'medium',
  hasPadding: false,
  open: false,
  onStateChange: function onStateChange() {},
  triggerClose: function triggerClose() {},
  scrollable: false
};

var _createClass$2$4 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$2$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$2$4(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$f(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$2$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$f(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UserMenu = function (_Component) {
  _inherits$2$4(UserMenu, _Component);

  function UserMenu() {
    _classCallCheck$2$4(this, UserMenu);

    return _possibleConstructorReturn$2$4(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).apply(this, arguments));
  }

  _createClass$2$4(UserMenu, [{
    key: 'renderAvatar',
    value: function renderAvatar() {
      var avatarUrl = this.props.user.avatarUrl;

      return React.createElement(Avatar$1, {
        image: avatarUrl,
        icon: avatarUrl ? null : 'user',
        alt: 'avatar',
        width: '48',
        height: '48',
        style: { marginLeft: '-1.5rem', marginRight: '1.5rem' }
      });
    }
  }, {
    key: 'renderLoggedInButton',
    value: function renderLoggedInButton() {
      var _props$user = this.props.user,
          firstName = _props$user.firstName,
          lastName = _props$user.lastName;

      return React.createElement(Button$6, { style: { paddingTop: 0, paddingBottom: 0 } }, React.createElement('div', { style: {
          display: 'flex',
          alignItems: 'center'
        } }, this.renderAvatar(), React.createElement('p', null, firstName, '\xA0', lastName)));
    }
  }, {
    key: 'renderProfile',
    value: function renderProfile() {
      var _props$user2 = this.props.user,
          firstName = _props$user2.firstName,
          lastName = _props$user2.lastName,
          avatarUrl = _props$user2.avatarUrl;

      return React.createElement('div', { style: {
          paddingTop: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        } }, React.createElement(Avatar$1, {
        image: avatarUrl,
        icon: avatarUrl ? null : 'user',
        alt: 'avatar',
        width: '48',
        height: '48' }), React.createElement('p', { className: 'u-margin-top-xs u-margin-bottom h5' }, firstName + ' ' + lastName));
    }
  }, {
    key: 'renderLoggedIn',
    value: function renderLoggedIn() {
      var _props = this.props,
          children = _props.children,
          flyoutSize = _props.flyoutSize,
          logoutUrl = _props.logoutUrl;

      return React.createElement(Flyout$2, {
        trigger: this.renderLoggedInButton(),
        direction: 'right',
        hasPadding: false,
        size: flyoutSize
      }, React.createElement('div', null, this.renderProfile(), children, React.createElement(Button$6, {
        onClick: function onClick() {
          return window.location.href = logoutUrl;
        },
        block: true,
        type: 'danger',
        iconLeft: 'power-off' }, 'Afmelden')));
    }
  }, {
    key: 'renderLoggedOut',
    value: function renderLoggedOut() {
      var loginUrl = this.props.loginUrl;

      return React.createElement(Button$6, { onClick: function onClick() {
          return window.location.href = loginUrl;
        }, iconLeft: 'user' }, 'Aanmelden');
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement('div', { style: { textAlign: this.props.direction } }, this.props.loggedIn ? this.renderLoggedIn() : this.renderLoggedOut());
    }
  }]);

  return UserMenu;
}(Component);

UserMenu.defaultProps = {
  direction: 'right',
  flyoutSize: 'small'
};

var _typeof$g = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Accordion = function Accordion(_ref) {
  var children = _ref.children;
  return React.createElement("div", { className: "m-accordion" }, children);
};

Accordion.defaultProps = {
  children: null
};

var _createClass$l = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck$l(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$l(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$g(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$l(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$g(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AccordionTab = function (_React$Component) {
  _inherits$l(AccordionTab, _React$Component);

  function AccordionTab(props) {
    _classCallCheck$l(this, AccordionTab);

    var _this = _possibleConstructorReturn$l(this, (AccordionTab.__proto__ || Object.getPrototypeOf(AccordionTab)).call(this, props));

    _this.state = {
      isOpen: props.open
    };
    return _this;
  }

  _createClass$l(AccordionTab, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({ isOpen: this.props.open });
      }
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      var isOpen = this.state.isOpen;

      this.setState({
        isOpen: !isOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var isOpen = this.state.isOpen;

      return React.createElement('div', {
        role: 'button',
        tabIndex: '0',
        onKeyPress: function onKeyPress() {
          return _this2.toggle();
        },
        onClick: function onClick() {
          return _this2.toggle();
        },
        className: classNames('m-accordion__tab', { 'is-open': isOpen })
      }, children);
    }
  }]);

  return AccordionTab;
}(React.Component);

AccordionTab.defaultProps = {
  open: false
};

var AccordionTabContent = function AccordionTabContent(_ref) {
  var children = _ref.children;
  return React.createElement("div", { className: "m-accordion__content" }, React.createElement("div", { className: "u-margin" }, children));
};

var AccordionTabHeader = function AccordionTabHeader(_ref) {
  var children = _ref.children;
  return React.createElement("div", { className: "m-accordion__header" }, children);
};

function _objectWithoutProperties$5(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var Link$2 = function Link(_ref) {
    var component = _ref.component,
        children = _ref.children,
        props = _objectWithoutProperties$5(_ref, ['component', 'children']);

    return createElement(component, props, children);
};

Link$2.defaultProps = { component: 'a' };

var _typeof$h = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Icon$a = function Icon(props) {
  var name = props.name,
      style = props.style,
      span = props.span,
      className = props.className;

  var iconClass = classNames(className, 'fa fa-' + name);

  if (span) {
    return React.createElement('span', { className: iconClass, style: style });
  } else {
    return React.createElement('i', { className: iconClass, style: style });
  }
};

var _createClass$m = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty$e(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck$m(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$m(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$h(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$m(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$h(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizeClasses$9 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$a = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent'
};

var Button$7 = function (_Component) {
  _inherits$m(Button, _Component);

  function Button() {
    _classCallCheck$m(this, Button);

    return _possibleConstructorReturn$m(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass$m(Button, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          negative = _props.negative,
          outline = _props.outline,
          transparent = _props.transparent,
          className = _props.className,
          children = _props.children,
          icon = _props.icon,
          iconLeft = _props.iconLeft,
          iconRight = _props.iconRight,
          onClick = _props.onClick,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          type = _props.type,
          size = _props.size,
          _props$block = _props.block,
          block = _props$block === undefined ? false : _props$block,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          htmlType = _props.htmlType;

      var btnClass = classNames('a-button', className, (_classNames = {}, _defineProperty$e(_classNames, '' + typeClasses$a[type], !!type), _defineProperty$e(_classNames, '' + sizeClasses$9[size], !!size), _defineProperty$e(_classNames, 'has-icon', !!icon), _defineProperty$e(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$e(_classNames, 'has-icon-right', !!iconRight), _defineProperty$e(_classNames, 'a-button-negative', !!negative), _defineProperty$e(_classNames, 'a-button-outline', !!outline), _defineProperty$e(_classNames, 'a-button--block', block), _classNames));

      return React.createElement('button', {
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType }, icon ? React.createElement(Icon$a, { name: icon }) : null, iconLeft ? React.createElement(Icon$a, { name: iconLeft }) : null, iconRight ? React.createElement(Icon$a, { name: iconRight }) : null, children);
    }
  }]);

  return Button;
}(Component);

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass$1$9 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck$1$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1$9(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof$h(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits$1$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof$h(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var sizes = {
  normal: '',
  large: 'm-modal--large'
};

var Modal = function (_React$Component) {
  _inherits$1$9(Modal, _React$Component);

  function Modal(props) {
    _classCallCheck$1$9(this, Modal);

    var _this = _possibleConstructorReturn$1$9(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.state = {
      showModal: false
    };

    _this.handleToggleModal = _this.handleToggleModal.bind(_this);
    _this.handleConfirm = _this.handleConfirm.bind(_this);
    _this.handleDeny = _this.handleDeny.bind(_this);
    _this.handleRequestClose = _this.handleRequestClose.bind(_this);

    var appElement = props.appElement,
        ariaHideApp = props.ariaHideApp;

    if (!Modal.appElement && ariaHideApp) {
      Modal.appElement = appElement;

      ReactModal.setAppElement(appElement);
    }
    return _this;
  }

  _createClass$1$9(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var openOnInit = this.props.openOnInit;

      this.handleToggleModal(!!openOnInit);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var showModal = this.state.showModal;
      var onAfterOpen = this.props.onAfterOpen;

      if (showModal) {
        Promise.resolve(onAfterOpen());
      }
    }
  }, {
    key: 'handleToggleModal',
    value: function handleToggleModal(show) {
      var showModal = this.state.showModal;

      this.setState({
        showModal: show !== undefined ? show : !showModal
      });
    }
  }, {
    key: 'handleConfirm',
    value: function handleConfirm() {
      var _this2 = this;

      var onConfirm = this.props.onConfirm;

      Promise.resolve(onConfirm()).then(function () {
        return _this2.handleToggleModal(false);
      });
    }
  }, {
    key: 'handleDeny',
    value: function handleDeny() {
      var _this3 = this;

      var onDeny = this.props.onDeny;

      Promise.resolve(onDeny()).then(function () {
        return _this3.handleToggleModal(false);
      });
    }
  }, {
    key: 'handleRequestClose',
    value: function handleRequestClose() {
      var _this4 = this;

      var onRequestClose = this.props.onRequestClose;

      Promise.resolve(onRequestClose()).then(function () {
        return _this4.handleToggleModal(false);
      });
    }
  }, {
    key: 'addProps',
    value: function addProps(Comp, props) {
      return React.createElement(Comp.type, _extends$4({}, Comp.props, props));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var showModal = this.state.showModal;

      var _props = this.props,
          appElement = _props.appElement,
          children = _props.children,
          onRequestClose = _props.onRequestClose,
          title = _props.title,
          hasCloseButton = _props.hasCloseButton,
          confirmText = _props.confirmText,
          denyText = _props.denyText,
          className = _props.className,
          overlayClassName = _props.overlayClassName,
          triggerElm = _props.triggerElm,
          triggerText = _props.triggerText,
          size = _props.size,
          restProps = _objectWithoutProperties$6(_props, ['appElement', 'children', 'onRequestClose', 'title', 'hasCloseButton', 'confirmText', 'denyText', 'className', 'overlayClassName', 'triggerElm', 'triggerText', 'size']);

      var modalTrigger = triggerElm ? this.addProps(triggerElm, {
        onClick: function onClick() {
          return _this5.handleToggleModal(true);
        }
      }) : React.createElement(Button$7, { type: 'primary', onClick: function onClick() {
          return _this5.handleToggleModal(true);
        } }, triggerText);

      var sizeClass = sizes[size];

      return React.createElement('div', null, modalTrigger, React.createElement(ReactModal, _extends$4({
        bodyOpenClassName: 'u-modal-open',
        htmlOpenClassName: 'u-modal-open',
        isOpen: showModal,
        onRequestClose: this.handleRequestClose,
        role: 'dialog',

        className: classNames('m-modal', sizeClass, className),
        overlayClassName: classNames('m-overlay', 'is-active', overlayClassName)

      }, restProps), React.createElement('div', { className: 'm-modal__content' }, (title || hasCloseButton) && React.createElement('div', { className: 'm-modal__header u-margin-bottom-xs' }, title && React.createElement('h6', null, title), hasCloseButton && React.createElement(Button$7, { className: 'm-modal__close', icon: 'times', transparent: true, onClick: function onClick() {
          return _this5.handleRequestClose();
        } })), children && React.createElement('div', { className: 'u-margin-bottom' }, children), (confirmText || denyText) && React.createElement('div', { className: 'm-modal__footer' }, confirmText && React.createElement(Button$7, { className: 'm-modal__confirm', type: 'primary', onClick: this.handleConfirm }, confirmText), denyText && React.createElement(Button$7, { className: 'm-modal__deny', type: 'secondary', onClick: this.handleDeny }, denyText)))));
    }
  }]);

  return Modal;
}(React.Component);

Modal.defaultProps = {
  appElement: '#root',
  ariaHideApp: true,

  hasCloseButton: true,
  title: '',

  confirmText: 'Yes',
  denyText: 'No',
  triggerElm: null,
  triggerText: 'Open',

  className: '',
  overlayClassName: '',
  size: 'normal',

  onConfirm: function onConfirm() {},
  onDeny: function onDeny() {},
  onRequestClose: function onRequestClose() {},
  onAfterOpen: function onAfterOpen() {},

  openOnInit: false
};

export { Alert, Autocomplete, Avatar, Badge, Button$1 as Button, Button$1 as ButtonGroup, Calendar$1 as Calendar, Card, CardBody, CardDescription, CardHeader, CardTitle, CardActions, CardIcon, CardImage, Contact$1 as Contact, Content, Flyout$1 as Flyout, FlyoutButton, Footer, Form, Checkbox, Fielset as Fieldset, TextField$1 as TextField, Select, Textarea, RadioGroup, InputLabel$1 as InputLabel, Datepicker, Header, Hero, Icon$7 as Icon, Label, Steps, Slider, Step, Spinner, Breadcrumbs, Switch, Tabs, TagList, TagListItem, Toggle, UserMenu, Accordion, AccordionTab, AccordionTabHeader, AccordionTabContent, Link$2 as Link, Modal };
